import Utils from '@/scripts/Utils';
import ConsumptionApi from '@/services/apiPdf/ConsumptionApi.js';
import UsersService from "@/services/server/UsersService";
import UnitsService from "@/services/server/UnitsService";
import SectorsService from "@/services/server/SectorsService";
import ChartConsumption from "@/components/charts/ChartsConsumption/Consumption.vue";
import ConsumptionFunctionsByTariff from "@/pages/ConsumptionByTariff/ConsumptionFunctionsByTariff.js"
import KpiCard from "@/components/KPI/KpiCard.vue";
import ConsumptionService from "@/services/server/ConsumptionService.js";
import ConsumptionBarChart from "@/components/charts/ConsumptionBarChart.vue";
import Rules from "@/utils/Rules";
import { showErrorSnackBar, showSuccessSnackBar, showInfoSnackBar } from "@/utils/SnackBartHelper";
import debounce from 'lodash/debounce';
import { mapGetters } from 'vuex';
import store from '@/store/index'
var { DateTime } = require("luxon");

const PROJECT_START_YEAR = '2020'
const MONTH = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]

import { generateXLSX } from "./ReportEconomyXLSXByTariff";

export default {

  name: "ConsumptionByTariff",

  components: {
    ConsumptionBarChart,
    //ChartConsumption,
    KpiCard
  },


  data() {
    return {
      unitsDataGraphic: [],
      summedGraphs: [],
      selectsLoading: {
        client: false,
        unit: false,
        sector: false
      },
      consultDatalLoading: {
        graphicButton: false,
        readingButton: false,
      },
      totalConsumptionUnitsSelected: false,
      groupingDataGraphic: false,
      monthListIndex: [],
      isDataGraphic: true,
      menuDateStart: false,
      menuDateEnd: false,
      dateFormattedSelectedPreviewStart: '',
      dateFormattedSelectedPreviewEnd: '',
      dateSelectedPreviewStart: Utils.formatDate(new Date(), "<YYYY>-<MM>-<dd>"),
      dateSelectedPreviewEnd: Utils.formatDate(new Date(), "<YYYY>-<MM>-<dd>"),
      lastReadingDate: '',
      previewDateCurrent: '',
      previewDate: null,
      dateSelectedEnd: '',
      data_abstract_client: {
        name: "Selecione um cliente",
        consumptionType: "-/-",
        registry: "-",
        address: "-",
        last_updated: "-"
      },
      readings_table_table1: [],
      readings_table_table2: [],
      loadButtonPdf: false,
      listClients: [],
      selectedClient: null,
      listUnits: [],
      selectedUnits: [],
      listSectors: [],
      selectedSector: [],
      readings: [],
      optionMetric: true,
      switch1: "Metros Cúbicos (m³)",
      validDayPeriodSelected: true,
      validHourPeriodSelected: true,
      validMonthPeriodSelected: true,
      consultReading: false,
      optionsToDisplay: [{ label: "Dia", value: "day" }],
      optionToDisplaySelected: "day",
      totalEstimatedConsumption: [],
      dateFormattedSelectedStart: '',
      dateFormattedSelectedEnd: '',
      kpiTipWater: 'Nomenclatura usada pela concessionária local para indicar o consumo de água registrado.',
      kpiTipSewage: 'Nomenclatura usada pela concessionária local para indicar o volume de esgoto registrado.',
      kpiTipGeneral: 'Nomenclatura usada pela concessionária local para indicar o volume de água e esgoto registrado.',
      dateSelectedFormatted: Utils.formatDate(new Date(), "<dd>/<MM>/<YYYY>"),
      dateSelectedStart: '',
      dateSelected: Utils.formatDate(new Date(), "<YYYY>-<MM>-<dd>"),
      menuDate: false,
      byMonth: MONTH,
      byYear: Utils.generateYearsByInterval(PROJECT_START_YEAR, 'now').map((date) => Utils.getDateInfo(date, false)['year']),
      monthSelected: MONTH[new Date().getMonth()],
      yearSelected: new Date().getFullYear(),
      optionPeriod: 'Últimos 7 dias',
      consultGraph: false,
      consultTable: false,
      graphicFlag: false,
      isDataTable: false,
      headers_tabledays: [
        { text: 'Data', align: 'center', sortable: false, value: 'date' },
        { text: 'Medição', value: 'value', align: 'center', },
      ],
      readings_table: [],
      monthListIndex: {
        Janeiro: { month: 1 },
        Fevereiro: { month: 2 },
        Março: { month: 3 },
        Abril: { month: 4 },
        Maio: { month: 5 },
        Junho: { month: 6 },
        Julho: { month: 7 },
        Agosto: { month: 8 },
        Setembro: { month: 9 },
        Outubro: { month: 10 },
        Novembro: { month: 11 },
        Dezembro: { month: 12 }
      },
      loadingReadings: false,
      dateOptions: {
        startDate: DateTime.utc()
          .setZone("America/Sao_Paulo")
          .startOf("day")
          .toSeconds(),
        endDate: DateTime.utc().setZone("America/Sao_Paulo").toSeconds(),
        mode: "day",
      },
      chartMenuItems: ["Últimos 7 dias", "Por mês", "Por dia", "Por hora", "Por intervalo", "Período de leitura estimado"],
      dialog: false,
      showNextReading: false,
      nextDateFormated: '',
      resume: {},
      totalDates: 0,
      permittedStartDate: null,
      permittedEndDate: null,
      selectsModal: false,
      validForm: true,
      fileLink: null,
      dialogDownload: false,
      unitSelectedDataKPIs: {},
      goalMonth: null,
      averageBeforeFozRaw: undefined,
      adjustedAverage: undefined,
      adjustedGoalEconomy: undefined,
      metaEconomy: undefined,
      exporting: false,
      recordedConsumption: null,
      recordedConsumptionRaw: null,
      isKPI: true,
      goalEconomy: '',
      generatingChart: false,
      dynamicHeight: '70vh',
      selectedUnitSum: [],
      selectedPeriod: '',
      kpiViewMode: 'total',
      kpiViewModes: [
        { text: 'Total', value: 'total' },
        { text: 'Água', value: 'water' },
        { text: 'Efluentes', value: 'sewer' },
      ],
      kpiMetricsRaw: {
        total: { recorded: null, average: null, estimated: null },
        water: { recorded: null, average: null, estimated: null },
        sewer: { recorded: null, average: null, estimated: null },
      },
      averageConsumption: '',
      estimatedTotal: undefined,
      // Tooltips dos KPIs
      kpiRecordedConsumptionTip: 'Representa o consumo total efetivamente medido (água + efluentes) no período selecionado.',
      kpiAverageConsumptionTip: 'Média de consumo diário no período selecionado, calculada a partir das leituras disponíveis.',
      kpiEstimatedTotalTip: 'Estimativa de consumo para o período completo, considerando medições já realizadas e projeções calculadas quando houver dias ou horários futuros selecionados.',
    };
  },

  computed: {
    ...mapGetters([
      'getSelectedUnit',
      'getSelectedSectors',
      'getSelectedUnits',
    ]),
    unitMeasureVuex() {
      return this.$store.getters.unitMeasure;
    },
    selectedPeriodValueVuex() {
      return this.$store.getters.selectedPeriodValue;
    },
    rulesRequiredArray() {
      return [this.requiredRuleArray()]
    },
    getNameByIdClient() {
      const client = this.listClients.find(({ id }) => id === this.selectedClient)
      return client ? client.name : ""
    },
    rulesRequired() {
      return Rules.required();
    },
    isCubicMetersSelected() {
      return this.switch1 == 'Metros Cúbicos (m³)'
    },
    isLitersSelected() {
      return !this.isCubicMetersSelected
    },
    unitMeasurement() {
      return this.isCubicMetersSelected ? 'cubic_meter' : 'liters'
    },
    likesAllUnits() {
      return this.selectedUnits.length === this.listUnits.length
    },
    likesSomeUnits() {
      return this.selectedUnits.length > 0 && !this.likesAllUnits
    },
    iconUnitSelect() {
      if (this.likesAllUnits) return 'mdi-close-box'
      if (this.likesSomeUnits) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    likesAllSectors() {
      return this.selectedSector.length === this.listSectors.length
    },
    likesSomeSectors() {
      return this.selectedSector.length > 0 && !this.likesAllSectors
    },
    iconSectorSelect() {
      if (this.likesAllSectors) return 'mdi-close-box'
      if (this.likesSomeSectors) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    consumptionType() {
      if (!this.unitSelectedDataKPIs || this.unitSelectedDataKPIs.consumptionType === undefined) {
        return ['', ''];
      }
      return this.unitSelectedDataKPIs.consumptionType.split('/');
    },
    selectedKpiModeLabel() {
      const selectedMode = this.kpiViewModes.find(({ value }) => value === this.kpiViewMode);
      return selectedMode ? selectedMode.text : 'Total';
    },
    showSplitAverageKpis() {
      return Array.isArray(this.selectedUnitSum)
        && this.selectedUnitSum.length > 0
        && this.kpiViewMode === 'total';
    },
    isSectorViewOnly() {
      return Array.isArray(this.selectedSector)
        && this.selectedSector.length > 0
        && (!Array.isArray(this.selectedUnitSum) || this.selectedUnitSum.length === 0);
    },
    averageWaterConsumption() {
      return this.formatKpiMetricValue(this.kpiMetricsRaw?.water?.average);
    },
    averageSewerConsumption() {
      return this.formatKpiMetricValue(this.kpiMetricsRaw?.sewer?.average);
    },
    kpiAverageWaterConsumptionTip() {
      return 'Média de consumo de água no período selecionado, calculada a partir das leituras disponíveis.';
    },
    kpiAverageSewerConsumptionTip() {
      return 'Média de consumo de efluentes no período selecionado, calculada a partir das leituras disponíveis.';
    },
    consumptionViewTitle() {
      return 'Visualização';
    },
    consumptionViewDescription() {
      const descriptions = {
        total: 'Água + efluentes',
        water: 'Somente água',
        sewer: 'Somente efluentes',
      };
      return descriptions[this.kpiViewMode] || descriptions.total;
    },
    kpiModeTheme() {
      const themes = {
        total: {
          cardBackground: '#EAF4FF',
          cardBorder: '#8BB8E8',
          switcherBackground: '#F7FBFF',
          activeButtonBackground: '#1565C0',
          activeButtonColor: '#FFFFFF',
          buttonBackground: '#FFFFFF',
          buttonColor: '#1565C0',
        },
        water: {
          cardBackground: '#E0EFFF',
          cardBorder: '#87B9FD',
          switcherBackground: '#F6FAFF',
          activeButtonBackground: '#87B9FD',
          activeButtonColor: '#FFFFFF',
          buttonBackground: '#FFFFFF',
          buttonColor: '#87B9FD',
        },
        sewer: {
          cardBackground: '#FFF1E5',
          cardBorder: '#F2B27B',
          switcherBackground: '#FFF8F2',
          activeButtonBackground: '#F2B27B',
          activeButtonColor: '#FFFFFF',
          buttonBackground: '#FFFFFF',
          buttonColor: '#F2B27B',
        },
      };
      return themes[this.kpiViewMode] || themes.total;
    },
    kpiCardStyle() {
      return {
        backgroundColor: this.kpiModeTheme.cardBackground,
        border: `1px solid ${this.kpiModeTheme.cardBorder}`,
        margin: '0px',
        minHeight: '68px',
        height: '68px',
        boxShadow: 'none'
      };
    },
    kpiModeSwitcherStyle() {
      return {
        backgroundColor: this.kpiModeTheme.switcherBackground,
        border: `1px solid ${this.kpiModeTheme.cardBorder}`,
        borderRadius: '14px',
        padding: '6px 8px',
        minHeight: '68px',
        height: '68px',
      };
    },
  },

  methods: {
    async getSectorsByUnitFromServer(unitId) {
      if (!unitId) return [];

      try {
        const response = await SectorsService.findByUnit(unitId);
        const sectors = response?.data?.data;
        return Array.isArray(sectors) ? sectors : [];
      } catch (error) {
        console.warn(`Não foi possível buscar os setores da unidade ${unitId} pelo backend`, error);
        return [];
      }
    },
    getKpiModeButtonStyle(mode) {
      const isActive = this.kpiViewMode === mode;
      const isDisabled = this.isKpiModeDisabled(mode);

      return {
        backgroundColor: isDisabled
          ? '#F3F5F7'
          : (isActive ? this.kpiModeTheme.activeButtonBackground : this.kpiModeTheme.buttonBackground),
        color: isDisabled
          ? '#A0A9B3'
          : (isActive ? this.kpiModeTheme.activeButtonColor : this.kpiModeTheme.buttonColor),
        opacity: isDisabled ? 0.65 : 1,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
      };
    },
    isKpiModeDisabled(mode) {
      return false;
    },
    getGraphBadgeStyle(kind = 'unit') {
      const palette = {
        unit: {
          background: '#DCEBFF',
          color: '#4A78B5',
          border: '1px solid #C4DBFF',
        },
        sector: {
          background: '#DCEBFF',
          color: '#4A78B5',
          border: '1px solid #C4DBFF',
        },
      };

      return {
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: '999px',
        padding: '6px 12px',
        fontSize: '12px',
        fontWeight: '700',
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
        ...palette[kind],
      };
    },
    formatConsumption(valueM3) {
      if (valueM3 == null || isNaN(valueM3)) return '-';

      if (this.unitMeasureVuex === 'liters') {
        return `${Math.round(valueM3 * 1000).toLocaleString('pt-BR')} L`;
      }

      return `${valueM3.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })} M³`;
    },
    getTariffTypeLabel(value, fallback = 'Não informado') {
      return typeof value === 'string' && value.trim() ? value.trim() : fallback;
    },
    getWaterSupplyTypeLabel(value, fallback = 'Tipo não informado') {
      const labels = {
        WELL: 'Poço',
        DEALERSHIP: 'Concessionária',
        RESERVOIR: 'Reservatório',
      };

      if (typeof value !== 'string' || !value.trim()) return fallback;
      return labels[value.trim()] || fallback;
    },
    findSelectedSectorByModemId(modemId) {
      if (!modemId || !Array.isArray(this.selectedSector)) return null;

      return this.selectedSector.find((sector) =>
        sector?.id_modem === modemId
        || sector?.id === modemId
        || sector?.id_doc === modemId
      ) || null;
    },
    getSectorSupplyTypesForReading(reading) {
      const modemId = reading?.modemId;
      const types = new Set();

      if (modemId && modemId !== 'groupReadings' && modemId !== 'somaTotal') {
        const resumeType = this.resume?.[modemId]?.modem?.waterSupplyType;
        const selectedSectorType = this.findSelectedSectorByModemId(modemId)?.waterSupplyType;

        if (resumeType) types.add(resumeType);
        if (selectedSectorType) types.add(selectedSectorType);
      }

      if (types.size === 0 && Array.isArray(this.selectedSector)) {
        this.selectedSector
          .map((sector) => sector?.waterSupplyType)
          .filter(Boolean)
          .forEach((type) => types.add(type));
      }

      return Array.from(types);
    },
    getSectorSupplyBadgeText(reading) {
      const supplyTypes = this.getSectorSupplyTypesForReading(reading);

      if (!Array.isArray(supplyTypes) || supplyTypes.length === 0) {
        return 'Tipo não informado';
      }

      const labels = supplyTypes
        .map((type) => this.getWaterSupplyTypeLabel(type, null))
        .filter(Boolean);

      if (labels.length === 0) return 'Tipo não informado';

      return labels.join(' + ');
    },
    getGraphBadgeTooltip(kind = 'unit') {
      if (kind === 'sector') {
        return 'Gráfico montado a partir das leituras dos setores selecionados.';
      }
      return 'Gráfico consolidado a partir das leituras da unidade selecionada.';
    },
    getSectorSupplyBadgeTooltip(reading) {
      const badgeText = this.getSectorSupplyBadgeText(reading);
      if (badgeText.includes('Concessionária') && badgeText.includes('Poço')) {
        return 'Setores mistos: concessionária pode espelhar água e esgoto, enquanto poço conta como esgoto.';
      }
      if (badgeText.includes('Concessionária')) {
        return 'Setor do tipo concessionária. Em unidade Real/Real, o esgoto é equivalente ao consumo de água.';
      }
      if (badgeText.includes('Poço')) {
        return 'Setor do tipo poço. A leitura do setor é considerada como esgoto.';
      }
      return `Tipo de abastecimento do setor: ${badgeText}.`;
    },
    getSectorDisplayName(sectorId) {
      const sector = this.findSectorDetails({ id_doc: sectorId, id: sectorId }) || {};
      return sector?.name || sector?.sectorName || sector?.modemName || 'Setor';
    },
    buildSectorResumeEntryFromTariffResponse(sectorConsumption) {
      const toCanonicalM3 = (value) => {
        const normalized = this.normalizeNumber(value, 0);
        return normalized / 1000;
      };
      const safeConsumptions = Array.isArray(sectorConsumption?.consumptions)
        ? sectorConsumption.consumptions
        : [];
      const labels = safeConsumptions.map((consumption) => {
        const date = new Date(consumption.time);
        return this.formatLabelByMode(date);
      });

      return {
        modemId: sectorConsumption?.sector_id,
        modemName: this.getSectorDisplayName(sectorConsumption?.sector_id),
        modem: this.findSectorDetails({ id_doc: sectorConsumption?.sector_id, id: sectorConsumption?.sector_id }),
        unitMeasurement: 'cubic_meter',
        measured_total: toCanonicalM3(sectorConsumption?.measured_consumption),
        estimated_total: toCanonicalM3(sectorConsumption?.estimated_total_consumption),
        average: toCanonicalM3(sectorConsumption?.average_current_consumption),
        measured_water: toCanonicalM3(sectorConsumption?.totalWaterMeasured),
        measured_sewer: toCanonicalM3(sectorConsumption?.totalSewerMeasured),
        average_water: toCanonicalM3(sectorConsumption?.totalWaterAverageCurrent),
        average_sewer: toCanonicalM3(sectorConsumption?.totalSewerAverageCurrent),
        estimated_water: toCanonicalM3(sectorConsumption?.totalWaterEstimatedTotal),
        estimated_sewer: toCanonicalM3(sectorConsumption?.totalSewerEstimatedTotal),
        labels,
        readings: safeConsumptions.map((consumption) => {
          const date = new Date(consumption.time);
          const waterValue = toCanonicalM3(consumption?.valueWater);
          const sewerValue = toCanonicalM3(consumption?.valueSewer);
          const fallbackTotal = toCanonicalM3(consumption?.valueTotal ?? (waterValue + sewerValue));

          return {
            date,
            label: this.formatLabelByMode(date),
            water: fallbackTotal,
            waterValue,
            sewerValue,
            isEstimative: Boolean(consumption?.isEstimative),
          };
        }),
      };
    },
    async generateSectorTariffConsumption(startDate, endDate, sectors = []) {
      const sectorIds = (Array.isArray(sectors) ? sectors : [])
        .map((sector) => sector?.id_doc || sector?.id)
        .filter(Boolean);

      if (!sectorIds.length) {
        return { permittedStartDate: null, permittedEndDate: null, resume: {}, labels: [] };
      }

      const adjustedEndDate = this.selectedPeriod !== 'hour'
        ? new Date(endDate.getTime() - 24 * 60 * 60 * 1000)
        : endDate;

      const response = await ConsumptionService.consumptionBySectorsByTariff({
        start_date: startDate,
        end_date: adjustedEndDate,
        mode: this.dateOptions.mode,
        unit_measurement: 'liters',
        sector_ids: sectorIds,
      });

      const sectorsData = Array.isArray(response?.data?.data) ? response.data.data : [];
      const resume = sectorsData.reduce((acc, sectorConsumption) => {
        const key = sectorConsumption?.sector_id;
        if (!key) return acc;
        acc[key] = this.buildSectorResumeEntryFromTariffResponse(sectorConsumption);
        return acc;
      }, {});

      const labels = sectorsData[0]?.consumptions?.map((consumption) => {
        const date = new Date(consumption.time);
        return {
          date,
          liters: 0,
          label: this.formatLabelByMode(date),
        };
      }) || [];

      const { permittedStartDate, permittedEndDate } = ConsumptionFunctionsByTariff.checkPeriod(labels, this.dateOptions.mode);
      return { permittedStartDate, permittedEndDate, resume, labels };
    },
    findSectorDetails(sectorCandidate) {
      if (!sectorCandidate || typeof sectorCandidate !== 'object') return null;

      const candidates = [
        ...(Array.isArray(this.listSectors) ? this.listSectors : []),
        ...(Array.isArray(this.getSelectedSectors) ? this.getSelectedSectors : []),
        ...(Array.isArray(this.selectedSector) ? this.selectedSector : []),
      ];

      return candidates.find((sector) =>
        sector?.id_doc === sectorCandidate?.id_doc
        || (sector?.id && sectorCandidate?.id && sector.id === sectorCandidate.id)
        || (sector?.id_modem && sectorCandidate?.id_modem && sector.id_modem === sectorCandidate.id_modem)
      ) || null;
    },
    hydrateSectorSelection(sectors = this.selectedSector) {
      if (!Array.isArray(sectors)) return [];

      return sectors.map((sector) => {
        const resolvedSector = this.findSectorDetails(sector);
        return resolvedSector ? { ...resolvedSector, ...sector, waterSupplyType: resolvedSector.waterSupplyType || sector?.waterSupplyType } : sector;
      });
    },
    syncResolvedSectorTypes() {
      if (!Array.isArray(this.selectedSector) || this.selectedSector.length === 0) return;

      const hydratedSectors = this.hydrateSectorSelection(this.selectedSector);
      const hasChanges = hydratedSectors.some((sector, index) => {
        const currentSector = this.selectedSector[index] || {};
        return sector?.waterSupplyType !== currentSector?.waterSupplyType;
      });

      if (hasChanges) {
        this.selectedSector = hydratedSectors;
      }
    },
    getUnitTariffsInfo(unitPayload) {
      const tariffs = unitPayload?.tarrifsTypes;
      const water = tariffs?.water || {};
      const sewer = tariffs?.sewer || {};

      return {
        water: {
          tariffType: this.getTariffTypeLabel(water?.tariffType),
          value: this.normalizeNumber(water?.value, 0),
        },
        sewer: {
          tariffType: this.getTariffTypeLabel(sewer?.tariffType),
          value: this.normalizeNumber(sewer?.value, 0),
        },
      };
    },
    buildUnitTariffChips(unitPayload) {
      const tariffs = this.getUnitTariffsInfo(unitPayload);

      const waterLabel = tariffs.water.tariffType === 'Fixo' && tariffs.water.value > 0
        ? `Água: ${tariffs.water.tariffType} • ${this.formatConsumption(tariffs.water.value)}`
        : `Água: ${tariffs.water.tariffType}`;

      const sewerLabel = tariffs.sewer.tariffType === 'Fixo' && tariffs.sewer.value > 0
        ? `Esgoto: ${tariffs.sewer.tariffType} • ${this.formatConsumption(tariffs.sewer.value)}`
        : `Esgoto: ${tariffs.sewer.tariffType}`;

      return [waterLabel, sewerLabel];
    },
    hasResolvedTariffsInfo(tariffsInfo) {
      if (!tariffsInfo || typeof tariffsInfo !== 'object') return false;
      const waterType = tariffsInfo?.water?.tariffType;
      const sewerType = tariffsInfo?.sewer?.tariffType;
      return waterType && waterType !== 'Não informado' && sewerType && sewerType !== 'Não informado';
    },
    syncResolvedUnitTariffs() {
      const firstSelectedUnit = Array.isArray(this.selectedUnitSum) && this.selectedUnitSum.length > 0
        ? this.selectedUnitSum[0]
        : null;
      const unitId = firstSelectedUnit?.id || this.getSelectedUnit?.id || this.selectedUnits?.[0];
      if (!unitId) return;

      const resolvedUnit = this.getSelectedUnitPayload(unitId);
      const resolvedTariffs = this.getUnitTariffsInfo(resolvedUnit);

      if (!this.hasResolvedTariffsInfo(resolvedTariffs)) return;

      this.unitSelectedDataKPIs = {
        ...(this.unitSelectedDataKPIs || {}),
        consumptionType: `${resolvedTariffs.water.tariffType} / ${resolvedTariffs.sewer.tariffType}`,
        tariffsTypes: resolvedTariffs,
      };

      if (Array.isArray(this.selectedUnitSum) && this.selectedUnitSum.length > 0 && this.isDataGraphic) {
        this.rebuildUnitCharts();
      }
    },

    scaleChartValue(valueM3) {
      if (typeof valueM3 !== 'number' || Number.isNaN(valueM3)) return null;
      return this.unitMeasureVuex === 'liters' ? valueM3 * 1000 : valueM3;
    },
    normalizeNumber(value, fallback = null) {
      if (typeof value === 'number' && !Number.isNaN(value)) return value;
      if (typeof value === 'string') {
        const parsed = Number(String(value).replace(',', '.'));
        if (!Number.isNaN(parsed)) return parsed;
      }
      return fallback;
    },
    parseSafeDate(value) {
      if (!value) return null;
      const parsedDate = value instanceof Date ? value : new Date(value);
      return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    },
    getArrayFromCandidates(candidates = []) {
      for (const candidate of candidates) {
        if (Array.isArray(candidate)) return candidate;
      }
      return [];
    },
    createEmptyKpiMetrics() {
      return {
        total: { recorded: 0, average: 0, estimated: 0 },
        water: { recorded: 0, average: 0, estimated: 0 },
        sewer: { recorded: 0, average: 0, estimated: 0 },
      };
    },
    formatKpiMetricValue(value) {
      if (value == null || isNaN(value)) return 'Não há dados';
      return this.formatConsumption(value);
    },
    getKpiModeDescription(mode = this.kpiViewMode) {
      const descriptions = {
        total: 'água + efluentes',
        water: 'água',
        sewer: 'efluentes',
      };
      return descriptions[mode] || descriptions.total;
    },
    updateDisplayedKpis() {
      const metrics = (this.kpiMetricsRaw && this.kpiMetricsRaw[this.kpiViewMode]) || {};
      this.recordedConsumption = this.formatKpiMetricValue(metrics.recorded);
      this.averageConsumption = this.formatKpiMetricValue(metrics.average);
      this.estimatedTotal = this.formatKpiMetricValue(metrics.estimated);

      const modeDescription = this.getKpiModeDescription();
      this.kpiRecordedConsumptionTip = `Representa o consumo efetivamente medido de ${modeDescription} no período selecionado.`;
      this.kpiAverageConsumptionTip = `Média de consumo de ${modeDescription} no período selecionado, calculada a partir das leituras disponíveis.`;
      this.kpiEstimatedTotalTip = `Estimativa de consumo de ${modeDescription} para o período completo, considerando medições já realizadas e projeções calculadas quando houver dias ou horários futuros selecionados.`;
    },
    resetKpiMetrics() {
      this.kpiMetricsRaw = this.createEmptyKpiMetrics();
      this.updateDisplayedKpis();
    },
    getResumeMetricValue(entry, primaryKey, fallbackValue = 0) {
      if (entry && Object.prototype.hasOwnProperty.call(entry, primaryKey) && typeof entry[primaryKey] === 'number') {
        return entry[primaryKey];
      }
      return fallbackValue;
    },
    normalizeResumeMetricValue(entry, value) {
      if (value == null || isNaN(value)) return 0;
      if (entry && entry.unitMeasurement === 'liters') {
        return value / 1000;
      }
      return value;
    },
    buildKpiMetricsFromResume(resume) {
      const metrics = this.createEmptyKpiMetrics();
      const entries = Object.entries(resume || {})
        .filter(([key, value]) => key !== 'goal' && value && typeof value === 'object')
        .map(([_, value]) => value);

      entries.forEach((entry) => {
        const totalRecorded = this.normalizeResumeMetricValue(entry, this.getResumeMetricValue(entry, 'measured_total', 0));
        const totalAverage = this.normalizeResumeMetricValue(entry, this.getResumeMetricValue(entry, 'average', 0));
        const totalEstimated = (() => {
          if (Object.prototype.hasOwnProperty.call(entry, 'estimatedTotal') && typeof entry.estimatedTotal === 'number') {
            return entry.estimatedTotal;
          }
          if (Object.prototype.hasOwnProperty.call(entry, 'estimated_total') && typeof entry.estimated_total === 'number') {
            return this.normalizeResumeMetricValue(entry, entry.estimated_total);
          }
          if (Array.isArray(entry.readings)) {
            return entry.readings
              .filter(reading => reading.isEstimative === true)
              .reduce((sum, reading) => {
                const rawValue = Number(reading.water) || 0;
                return sum + this.normalizeResumeMetricValue(entry, rawValue);
              }, 0);
          }
          return 0;
        })();

        const waterRecorded = this.normalizeResumeMetricValue(entry, this.getResumeMetricValue(entry, 'measured_water', totalRecorded));
        const sewerRecorded = this.normalizeResumeMetricValue(entry, this.getResumeMetricValue(entry, 'measured_sewer', 0));
        const waterAverage = this.normalizeResumeMetricValue(entry, this.getResumeMetricValue(entry, 'average_water', totalAverage));
        const sewerAverage = this.normalizeResumeMetricValue(entry, this.getResumeMetricValue(entry, 'average_sewer', 0));
        const waterEstimated = this.normalizeResumeMetricValue(entry, this.getResumeMetricValue(entry, 'estimated_water', totalEstimated));
        const sewerEstimated = this.normalizeResumeMetricValue(entry, this.getResumeMetricValue(entry, 'estimated_sewer', 0));

        metrics.total.recorded += totalRecorded;
        metrics.total.average += totalAverage;
        metrics.total.estimated += totalEstimated;
        metrics.water.recorded += waterRecorded;
        metrics.water.average += waterAverage;
        metrics.water.estimated += waterEstimated;
        metrics.sewer.recorded += sewerRecorded;
        metrics.sewer.average += sewerAverage;
        metrics.sewer.estimated += sewerEstimated;
      });

      return metrics;
    },
    resetStateForEstimated() {
      // Limpa seleções
      this.selectedUnits = [];
      this.selectedUnitSum = [];
      this.selectedSector = [];
      this.listSectors = [];

      // Limpa dados calculados
      this.resume = {};
      this.readings = [];
      this.resetKpiMetrics();

      // Reseta estados visuais
      this.isDataGraphic = false;
      this.isDataTable = false;
      this.consultGraph = false;
      this.consultTable = false;
      this.generatingChart = false;

      // Reseta datas para evitar reaproveitamento inválido
      this.dateOptions = {
        startDate: null,
        endDate: null,
        mode: this.optionToDisplaySelected || 'day'
      };
    },

    formatLabelByMode(date) {
      if (this.dateOptions.mode === 'hour') {
        return `${date.getHours().toString().padStart(2, '0')}:00`;
      } else if (this.dateOptions.mode === 'month') {
        const monthNames = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear().toString().slice(-2);
        return `${month}/${year}`;
      } else {
        // day mode (padrão)
        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}`;
      }
    },
    toStringSafe(val) {
      return val == null ? '' : String(val);
    },
    requiredRuleArray(errorText = 'Campo requerido') {
      return value => value === null || !value.length ? errorText : true;
    },
    async syncSelectedSectorsFromVuex() {
      // Na tela de consumo, ignorar setores do tipo RESERVOIR mesmo que venham do Vuex
      const vuexSectors = (this.getSelectedSectors || []).filter(
        (s) => s.waterSupplyType !== 'RESERVOIR'
      );
      if (!vuexSectors.length) {
        this.selectedSector = [];
        return;
      }
      this.selectedSector = this.hydrateSectorSelection(vuexSectors);
      const unitIds = [...new Set(vuexSectors.map(s => s.id_unit))];
      this.selectedUnits = unitIds;
      if (unitIds.length) {
        await this.getSectorsByUnitId(unitIds);
      }
      const missingSectors = vuexSectors.filter(s => !this.listSectors.some(ls => ls.id_doc === s.id_doc));
      if (missingSectors.length) {
        this.listSectors = [...this.listSectors, ...missingSectors];
      }
      this.selectedSector = this.hydrateSectorSelection(vuexSectors);
      await this.onChangeSector(this.selectedSector);
      this.consultConsumptionGraphic()
    },
    /**
     * Ao entrar na página de Consumo com alguma unidade já selecionada na RightSidebar,
     * garante que os setores visíveis (não RESERVOIR) dessa unidade sejam selecionados
     * caso ainda não exista nenhum setor selecionado.
     */
    async ensureSectorsForSelectedUnitIfMissing() {
      const selectedUnit = this.getSelectedUnit;
      if (!selectedUnit) return;

      const vuexSectors = (this.getSelectedSectors || []).filter(
        (s) => s.waterSupplyType !== 'RESERVOIR'
      );

      // Se já existem setores (não reservatório) selecionados no Vuex, não faz nada
      if (vuexSectors.length > 0) {
        return;
      }

      // Busca setores da unidade selecionada e seleciona todos os setores visíveis
      const sectors = await this.getSectorsByUnitFromServer(selectedUnit.id);
      const visibleSectors = (sectors || []).filter(
        (s) => s.waterSupplyType !== 'RESERVOIR'
      );

      if (!visibleSectors.length) {
        this.selectedSector = [];
        return;
      }

      this.listSectors = visibleSectors;
      this.selectedSector = [...visibleSectors];
      this.selectedUnits = [selectedUnit.id];

      // Mantém Vuex sincronizado com a seleção feita aqui
      try {
        if (store && typeof store.dispatch === 'function') {
          await store.dispatch('setSelectedSectors', this.selectedSector);
          await store.dispatch('setSelectedUnits', [{ ...selectedUnit, unit: selectedUnit }]);
        }
      } catch (e) {
        console.warn('Não foi possível sincronizar setores/unidades com o Vuex:', e);
      }

      this.onChangeSector(this.selectedSector);
    },
    toggleSectorsList() {
      this.$nextTick(() => {
        if (this.likesAllSectors) {
          this.selectedSector = []
        } else {
          this.selectedSector = this.listSectors.slice()
        }
        this.onChangeSector(this.selectedSector)
      })
    },
    toggleUnitsList() {
      this.$nextTick(() => {
        if (this.likesAllUnits) {
          this.selectedUnits = []
        } else {
          this.selectedUnits = this.listUnits.slice().map((unit => unit.id))
        }
        this.onChangeUnit(this.selectedUnits)
      })
    },
    onKeydownSector(key) {
      if (key.code === 'Backspace') {
        this.closeInfoData();
        this.selectedSector = [];
      }
    },
    onChangeSector(sector) {
      this.readings_table = []
      this.groupingDataGraphic = false

      this.isDataGraphic = false;
      this.isDataTable = false;
    },
    onKeydownUnit(key) {
      if (key.code === 'Backspace') {
        this.closeInfoData();
        this.selectedUnits = [];
        this.selectedSector = [];
        this.listSectors = [];
      }
    },
    async getSectorsByUnitId(idUnits) {
      const execFuncs = idUnits.map((id) => this.getSectorsByUnitFromServer(id))

      await Promise.all(execFuncs).then((values) => {
        // Em consumo, a lista de setores não deve incluir reservatórios
        const allSectors = values.flatMap(value => Array.isArray(value) ? value : []);
        this.listSectors = allSectors.filter(
          (sector) => sector.waterSupplyType !== 'RESERVOIR'
        );
      })
      this.syncResolvedSectorTypes();
    },
    async onChangeUnit(unitData) {
      this.listSectors = [];
      //this.selectedSector = [];
      this.selectsLoading.sector = true
      // await this.getSectorsByUnitId(idUnits)
      this.closeInfoData();
      this.onChangeInfoUnit(unitData)
      //this.selectedSector = [];
      this.selectsLoading.sector = false
      if (this.listSectors.length === 1) this.selectedSector = this.listSectors;
    },
    onKeydownClient(key) {
      if (key.code === 'Backspace') {
        this.closeInfoData();
        this.selectedClient = [];
        this.selectedUnits = [];
        this.listUnits = [];
        this.selectedSector = [];
        this.listSectors = [];
      }
    },
    async onChangeClient(idClient) {
      this.selectsLoading.unit = true
      this.closeInfoData();
      this.selectedUnits = [];
      this.selectedSector = [];
      this.showNextReading = false;

      const response = await UnitsService.findAllByClient(idClient)
      this.listUnits = response.data.data
      this.selectsLoading.unit = false
      if (this.listUnits.length === 1) {
        this.selectedUnits = [this.listUnits[0].id];
        this.onChangeUnit(this.selectedUnits);
      }
    },

    async exportSheets() {
      if (!this.getSelectedUnit) {
        showInfoSnackBar("Selecione uma unidade para gerar a planilha")
        return
      }
      if (!this.checkSameUnit()) {
        showInfoSnackBar("Selecione apenas uma unidade para gerar a planilha")
        return
      }
      if (this.$refs.formConsumption && !this.$refs.formConsumption.validate()) return;
      if (!this.selectedSector.length) {
        showInfoSnackBar("Selecione ao menos um setor para gerar a planilha")
        return
      }
      this.exporting = true
      const currentResume = { ...this.resume };
      const currentReadings = [...this.readings];
      const currentIsDataGraphic = this.isDataGraphic;
      const currentIsDataTable = this.isDataTable;
      // Bloqueio: não permitir exportar múltiplas unidades quando período estimado
      const currentPeriod = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
      if (currentPeriod === 'estimed' && Array.isArray(this.selectedUnitSum) && this.selectedUnitSum.length > 1) {
        showInfoSnackBar("Não é possível exportar múltiplas unidades com o período 'Estimado'. Selecione apenas uma unidade ou altere o período.");
        this.exporting = false
        return
      }

      await this.generateAllConsumption(true)
      let excelData = {
        unit_name: this.getSelectedUnit?.title || this.getSelectedUnit?.name || 'Unidade',
        sectors: []
      }
      let totalWater = 0;
      let resumeValues = Object.entries(this.resume)
        .filter(([key, _]) => key !== 'goal')
        .map(([_, value]) => value)
      for (let i = 0; i < resumeValues.length; i++) {
        let resume = resumeValues[i]
        let modemName = resume['modemName']
        let rows = []
        rows.push(modemName)
        resume.readings.forEach(
          (reading) => {
            totalWater += reading.water;
            let row = [reading.label, (reading.water * 1000).toFixed(0), reading.water.toFixed(3).replace('.', ',')]
            rows.push(row)
          }
        )
        let lastRow = ['Total', (totalWater * 1000).toFixed(0), totalWater.toFixed(3).replace('.', ',')]
        rows.push(lastRow)
        excelData.sectors.push(rows)
      }
      await generateXLSX(excelData)

      this.resume = currentResume;
      this.readings = currentReadings;
      this.isDataGraphic = currentIsDataGraphic;
      this.isDataTable = currentIsDataTable;
      this.exporting = false
    },
    estimatedConsumption(total, estimated) {
      let sum = total + estimated
      return sum.toFixed(2)
    },

    getEstimatedTotal(resume) {
      if (!resume || typeof resume !== 'object') {
        return 0;
      }
      const keys = Object.keys(resume).filter(key => key !== 'goal');
      if (keys.length === 0) {
        return 0;
      }
      let totalEstimated = 0;

      for (const key of keys) {
        const item = resume[key];

        // Verifica se é um resume de unidade (tem estimatedTotal já calculado)
        if (item.hasOwnProperty('estimatedTotal') && typeof item.estimatedTotal === 'number') {
          // Para unidades: usa o valor já calculado pela API (em M³)
          totalEstimated += item.estimatedTotal;
        }
        // Se não tem estimatedTotal mas tem readings, é um resume de setor
        else if (item.hasOwnProperty('readings') && Array.isArray(item.readings)) {
          // Para setores: soma apenas leituras com isEstimative=true
          const estimatedFromReadings = item.readings
            .filter(reading => reading.isEstimative === true)
            .reduce((sum, reading) => {
              // reading.water já está no formato correto (M³ ou litros conforme unitMeasurement)
              const value = Number(reading.water) || 0;
              return sum + value;
            }, 0);

          totalEstimated += estimatedFromReadings;
        }
      }

      return this.formatConsumption(totalEstimated);
    },

    closeInfoData() {
      this.unitSelectedDataKPIs = {}
      this.data_abstract_client = {
        name: "Selecione um cliente",
        consumptionType: "-/-",
        registry: "-",
        address: "-",
        last_updated: "-"
      };
      this.isDataGraphic = false;
      this.isDataTable = false;
      this.resetKpiMetrics();

    },
    async onChangeInfoUnit(unitData) {
      const formatValue = (value) => {
        return new Intl.NumberFormat('pt-BR').format(value);
      }
      this.averageBeforeFozRaw = undefined
      const unitSelected = unitData.unit
      const unitTariffs = this.getUnitTariffsInfo(unitSelected);
      this.unitSelectedDataKPIs.goalEconomy = unitSelected && unitSelected.goalEconomy === undefined ? 'Não há dados' : (unitSelected ? unitSelected.goalEconomy : 'Não há dados');

      if (unitSelected.averageBeforeFoz !== undefined) {
        this.averageBeforeFozRaw = unitSelected.averageBeforeFoz || undefined;
        this.metaEconomy = unitSelected.metaEconomia / 100
        this.updateAdjustedAverage();
      }
      this.unitSelectedDataKPIs.goalPercentage = `${formatValue(unitSelected.metaEconomia)} %`
      this.unitSelectedDataKPIs.consumptionType = `${unitTariffs.water.tariffType} / ${unitTariffs.sewer.tariffType}`
      this.unitSelectedDataKPIs.tariffsTypes = unitTariffs
      await this.consultConsumptionGraphic()
      this.isDataGraphic = true
    },
    async startConsultTable() {
      this.graphicFlag = false;
      this.consultTable = false;
      this.consultGraph = false;
      this.isDataGraphic = false;
      this.isDataTable = false;
      // Ativa flags que permite fazer a impressão e também flag de carregamento dos dados (vue loading)
      if (this.$refs.formConsumption && !this.$refs.formConsumption.validate()) return;

      // Bloqueio: não permitir tabela com múltiplas unidades quando período estimado
      const currentPeriod = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
      if (currentPeriod === 'estimed' && Array.isArray(this.selectedUnitSum) && this.selectedUnitSum.length > 1) {
        showInfoSnackBar("Não é possível gerar tabela para múltiplas unidades com o período 'Estimado'. Selecione apenas uma unidade ou altere o período.");
        return;
      }

      this.loadingReadings = true;
      this.readings_table = []
      this.validDayPeriodSelected = true;
      this.validHourPeriodSelected = true;
      this.validMonthPeriodSelected = true;


      this.consultDatalLoading.readingButton = true
      await this.generateAllConsumption(false)
      this.consultDatalLoading.readingButton = false

      this.readings_table = ConsumptionFunctionsByTariff.createDataTable(this.resume)

      if (this.isCubicMetersSelected) {
        this.headers_tabledays = [
          { text: 'Data', align: 'center', sortable: false, value: 'date' },
          { text: 'Medição (m³)', value: 'value', align: 'center', },
        ]
      } else {
        this.headers_tabledays = [
          { text: 'Data', align: 'center', sortable: false, value: 'date' },
          { text: 'Medição (L)', value: 'value', align: 'center', },
        ]
      }
      this.consultReading = false;
      this.isDataGraphic = false;        // Não exibe gráfico
      this.isDataTable = true;
      this.consultGraph = false;
      this.loadingReadings = false;
      this.selectsModal = false


    },
    getResumeData(modemId, key) {
      if (modemId === "groupReadings" || modemId === "somaTotal") {
        return null;
      }
      if (!this.resume.hasOwnProperty(modemId)) throw new Error(`Não foi encontrado o modem '${modemId}' no resumo dos dados`)
      let resumeModem = this.resume[modemId]
      if (!resumeModem.hasOwnProperty(key)) throw new Error(`Não foi encontrado o dado '${key}' no resumo dos dados`)
      return resumeModem[key]
    },
    generateModemIds() {
      let modems = []
      if (!Array.isArray(this.selectedSector)) {
        modems.push(this.selectedSector)
      } else {
        modems = this.selectedSector
      }
      let modemIds = modems.map((modem) => modem.id_modem)
      return modemIds
    },
    getPeriod() {
      let startDate = null
      let endDate = null
      const { period, startDate: localStartDate, endDate: localEndDate } = this.$store.getters.selectedPeriodValue || {};
      if (period === 'estimed' && this.selectedUnitSum.length > 1) {
        this.resetStateForEstimated();
        showInfoSnackBar(
          "O período estimado permite apenas uma unidade. As seleções foram redefinidas."
        );
        return { startDate: null, endDate: null };
      }
      this.selectedPeriod = period
      // Se período selecionado foi 'Últimos 7 dias'
      if (period == '7days') { // ok
        this.dateOptions.startDate = Utils.add_day(Utils.getMidnightToday(), -7)
        this.dateOptions.endDate = Utils.getLastDateOfDay(Utils.subtractDate(Utils.getMidnightToday(), 1, 'day'))
        this.dateOptions.mode = "day";
        // Convertendo para o intervalo correspondente
        startDate = this.dateOptions.startDate
        endDate = this.dateOptions.endDate
        this.goalMonth = parseFloat((this.goalMonth / 30).toFixed(2));
      } else if (period == 'day') { // ok
        // Trata o mês ao qual o usuário selecionou.
        this.yearSelected = parseInt(this.yearSelected);
        this.dateOptions.startDate = Utils.instanceDate(`${localStartDate.getFullYear()}-${localStartDate.getMonth() + 1}`);
        startDate = this.dateOptions.startDate
        this.dateOptions.endDate = Utils.getLastDayOfMonth(startDate)
        this.dateOptions.mode = "day";
        this.goalMonth = parseFloat((this.goalMonth / 30).toFixed(2));
        //`${yearSelect}-`
        endDate = Utils.getLastDateOfDay(Utils.getLastDayOfMonth(startDate))
      } else if (period == 'month') { // ok
        this.dateOptions.startDate = Utils.instanceDate(`${localStartDate.getFullYear()}-${localStartDate.getMonth() + 1}-01 00:00:00`);
        const year = localEndDate.getFullYear();
        const month = localEndDate.getMonth() + 1;
        const lastDay = new Date(year, month, 0).getDate();
        this.dateOptions.endDate = Utils.instanceDate(`${year}-${month}-${lastDay} 23:59:59`);
        this.dateOptions.mode = "month";
        startDate = this.dateOptions.startDate
        endDate = this.dateOptions.endDate
      } else if (period == 'hour') { // ok
        // Quebra data selecionada para o usuário, afim de facilitar a construção do vetor com o intervalo do gráfico.
        var dateSelect = (this.dateSelected && typeof this.dateSelected === 'string' && this.dateSelected.includes('-'))
          ? this.dateSelected.split('-')
          : [];
        // Converte cada elemento do array para inteiro.       
        const year = localStartDate.getFullYear();
        const month = localStartDate.getMonth();
        const day = localStartDate.getDate();
        // Inicializando parâmetros de data
        this.dateOptions.startDate = Utils.instanceDate(`${year}-${month + 1}-${day} 00:00:00`);
        this.dateOptions.endDate = Utils.instanceDate(`${year}-${month + 1}-${day} 23:59:59`);
        this.dateOptions.mode = "hour";
        startDate = this.dateOptions.startDate
        endDate = this.dateOptions.endDate
        this.goalMonth = parseFloat(((this.goalMonth / 30) / 24).toFixed(2));
      } else if (period == 'interval') { // ok     
        const yearStart = localStartDate.getFullYear();
        const monthStart = localStartDate.getMonth();
        const dayStart = localStartDate.getDate();
        const yearEnd = localEndDate.getFullYear();
        const monthEnd = localEndDate.getMonth();
        const dayEnd = localEndDate.getDate();
        this.dateOptions.startDate = Utils.instanceDate(`${yearStart}-${monthStart + 1}-${dayStart} 00:00:00`);
        this.dateOptions.endDate = Utils.instanceDate(`${yearEnd}-${monthEnd + 1}-${dayEnd} 23:59:59`);
        this.dateOptions.mode = this.optionToDisplaySelected;
        startDate = this.dateOptions.startDate
        endDate = this.dateOptions.endDate
        this.goalMonth = parseFloat((this.goalMonth / 30).toFixed(2));
      } else if (period == 'estimed') { // ok
        var nullVar = null
        if (!this.selectedSector?.length) {
          //showInfoSnackBar("Selecione ao menos um setor para gerar a estimativa")
          this.consultDatalLoading.graphicButton = false
          return { nullVar, nullVar }
        }
        this.dateOptions.mode = this.optionToDisplaySelected;
        this.dateOptions.startDate = localStartDate
        this.dateOptions.endDate = localEndDate
        startDate = localStartDate
        endDate = localEndDate
        this.goalMonth = parseFloat((this.goalMonth / 30).toFixed(2));
      } else {
        throw new Error("Unidentified period")
      }
      return { startDate, endDate }
    },
    mountDataChart(resultConsumptionsUnit) {

      const labels = resultConsumptionsUnit.consumptions.map(consumption => {
        const date = new Date(consumption.time);
        return this.formatLabelByMode(date);
      });
      const goalValue = this.getGoalConsumptionByPeriod();
      const waterDataset = {
        label: 'Água',
        data: resultConsumptionsUnit.consumptions.map(consumption => consumption.valueWater),  // Exemplo: [10, 20, 30, 0]
        backgroundColor: '#2FA4DD',
        borderColor: '#2FA4DD',
        fill: false,
        draw: false,
        borderSkipped: false,
        // barThickness: 30,
        order: 1,
        unitMeasure: this.unitMeasureVuex
      };

      // Adicionar meta de consumo se disponível
      if (goalValue !== null && goalValue !== undefined && !isNaN(goalValue)) {
        waterDataset.goalConsumption = parseFloat(goalValue.toFixed(2));
      }

      const dataset = [
        waterDataset,
        {
          label: 'Efluentes',
          data: resultConsumptionsUnit.consumptions.map(consumption => consumption.valueSewer),  // Exemplo: [5, 0, 10, 15]
          backgroundColor: '#F28C28',
          borderColor: '#F28C28',
          fill: false,
          draw: false,
          borderSkipped: false,
          // barThickness: 30,
          order: 1
        },
        {
          label: 'Média Água',
          data: Array(labels.length).fill(resultConsumptionsUnit.totalWaterAverageCurrent), // Cria um array com a média repetida
          type: 'line',
          borderColor: '#0E76BC',
          backgroundColor: '#0E76BC',
          borderWidth: 1,
          fill: false,
          pointRadius: 0, // Remove os pontos da linha
          order: 2,
        },
        // Linha média para Consumo de Esgoto
        {
          label: 'Média Efluentes',
          data: Array(labels.length).fill(resultConsumptionsUnit.totalSewerAverageCurrent), // Cria um array com a média repetida
          type: 'line',
          borderColor: '#C96A12',
          backgroundColor: '#C96A12',
          borderWidth: 1,
          fill: false,
          pointRadius: 0, // Remove os pontos da linha
          order: 2,
        },
      ]

      return { labels, dataset }
    },
    shadeColor(hex, percent) {
      hex = hex.replace(/^#/, '');

      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);

      r = Math.min(255, Math.max(0, r + Math.round((255 - r) * percent / 100)));
      g = Math.min(255, Math.max(0, g + Math.round((255 - g) * percent / 100)));
      b = Math.min(255, Math.max(0, b + Math.round((255 - b) * percent / 100)));

      return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
    },
    getSelectedUnitPayload(unitId) {
      const selectedUnit = (this.selectedUnitSum || []).find(({ id }) => id === unitId);
      if (selectedUnit?.unit) return selectedUnit.unit;
      if (selectedUnit?.tarrifsTypes) return selectedUnit;

      const listUnit = (this.listUnits || []).find(({ id }) => id === unitId);
      if (listUnit?.tarrifsTypes) return listUnit;

      if (this.getSelectedUnit?.id === unitId) {
        return this.getSelectedUnit.unit || this.getSelectedUnit;
      }

      return selectedUnit || listUnit || null;
    },
    getCurrentBaselineConfig(unitPayload) {
      if (!unitPayload || typeof unitPayload !== 'object') return null;

      const directConfig = unitPayload.currentBaselineConfig ||
        unitPayload.currentBaseline ||
        unitPayload.baselineConfigCurrent ||
        unitPayload.baselineConfig ||
        unitPayload.baseline;

      if (directConfig && typeof directConfig === 'object') {
        return directConfig;
      }

      const history = this.getArrayFromCandidates([
        unitPayload.baseline_configs,
        unitPayload.baselineConfigs,
        unitPayload.baselineConfigHistory,
        unitPayload.baselineHistory,
      ]);

      if (!Array.isArray(history) || !history.length) return null;

      const now = new Date();
      return history
        .filter((item) => item && typeof item === 'object')
        .filter((item) => {
          const validFrom = this.parseSafeDate(item.validFrom);
          const validTo = this.parseSafeDate(item.validTo);
          return (!validFrom || validFrom <= now) && (!validTo || validTo >= now);
        })
        .sort((a, b) => {
          const aTime = this.parseSafeDate(a.validFrom)?.getTime() || 0;
          const bTime = this.parseSafeDate(b.validFrom)?.getTime() || 0;
          return bTime - aTime;
        })[0] || history[0] || null;
    },
    getBaselineReferenceMode(config) {
      return config?.referenceMode || config?.baselineMode || config?.mode || config?.type || null;
    },
    getBaselineMetricValue(source, type) {
      if (!source || typeof source !== 'object') return null;

      const keys = type === 'water'
        ? ['water', 'valueWater', 'waterValue', 'baselineWater']
        : ['sewer', 'valueSewer', 'sewerValue', 'baselineSewer', 'effluent'];

      for (const key of keys) {
        const value = this.normalizeNumber(source[key]);
        if (value !== null) {
          return value;
        }
      }

      return null;
    },
    normalizeMonthlyBaselineEntries(config) {
      const monthlyBaseline = config?.monthlyBaseline;
      const rawEntries = this.getArrayFromCandidates([
        monthlyBaseline?.months,
        monthlyBaseline?.distribution,
        monthlyBaseline?.values,
        monthlyBaseline,
        config?.months,
      ]);

      if (!Array.isArray(rawEntries)) return [];

      return rawEntries
        .map((entry, index) => ({
          month: this.normalizeNumber(entry?.month || entry?.monthNumber || entry?.monthIndex || entry?.referenceMonth || index + 1, index + 1),
          water: this.getBaselineMetricValue(entry, 'water'),
          sewer: this.getBaselineMetricValue(entry, 'sewer'),
        }))
        .filter((entry) => entry.month >= 1 && entry.month <= 12);
    },
    convertBaselineValueToChartScale(value, date, mode) {
      if (typeof value !== 'number' || Number.isNaN(value)) return null;

      if (mode === 'hour') {
        const daysInMonth = DateTime.fromJSDate(date).daysInMonth || 30;
        return value / daysInMonth / 24;
      }

      if (mode === 'day') {
        const daysInMonth = DateTime.fromJSDate(date).daysInMonth || 30;
        return value / daysInMonth;
      }

      return value;
    },
    getUnitAverageLabel(type) {
      const mode = this.getBaselineReferenceMode(this.getCurrentBaselineConfig(unitPayload));
      const target = type === 'water' ? 'Água' : 'Efluentes';

      if (mode === 'monthlyBaseline' || mode === 'monthly') {
        return `Baseline sazonal ${target}`;
      }

      if (mode === 'fixedBaseline' || mode === 'fixed') {
        return `Baseline fixa ${target}`;
      }

      return `Referência ${target}`;
    },
    buildUnitBaselineSeries(unitPayload, consumptions, type, fallbackValue) {
      const config = this.getCurrentBaselineConfig(unitPayload);
      const referenceMode = this.getBaselineReferenceMode(config);
      const monthlyEntries = this.normalizeMonthlyBaselineEntries(config);
      const periodMode = this.dateOptions?.mode || 'day';
      const safeConsumptions = Array.isArray(consumptions) ? consumptions : [];
      const normalizedFallback = this.normalizeNumber(fallbackValue);

      return safeConsumptions.map((consumption) => {
        const date = this.parseSafeDate(consumption?.time) || new Date();
        let baselineValue = null;

        if (referenceMode === 'monthlyBaseline' || referenceMode === 'monthly') {
          const month = date.getMonth() + 1;
          const entry = monthlyEntries.find((item) => item.month === month);
          baselineValue = entry ? entry[type] : null;
        } else if (referenceMode === 'fixedBaseline' || referenceMode === 'fixed') {
          baselineValue = this.getBaselineMetricValue(config.fixedBaseline || config, type);
        }

        if (baselineValue == null) {
          baselineValue = normalizedFallback;
        }

        const scaledValue = this.convertBaselineValueToChartScale(baselineValue, date, periodMode);
        const displayValue = typeof scaledValue === 'number' ? this.scaleChartValue(scaledValue) : null;
        return typeof displayValue === 'number' ? +displayValue.toFixed(2) : null;
      });
    },
    buildUnitChartSubtitle(unitPayload) {
      const mode = this.getBaselineReferenceMode(this.getCurrentBaselineConfig(unitPayload));
      const baselineLabel =
        mode === 'monthlyBaseline' || mode === 'monthly'
          ? 'Baseline mensal'
          : mode === 'fixedBaseline' || mode === 'fixed'
            ? 'Baseline fixa'
            : 'Referência atual';
      return `Gráfico da unidade • Visão ${this.selectedKpiModeLabel} • ${baselineLabel}`;
    },
    buildUnitAverageSeries(consumptions, averageValue) {
      const safeConsumptions = Array.isArray(consumptions) ? consumptions : [];
      const normalizedAverage = this.normalizeNumber(averageValue);
      const displayValue = typeof normalizedAverage === 'number'
        ? +this.scaleChartValue(normalizedAverage).toFixed(2)
        : null;
      return safeConsumptions.map(() => displayValue);
    },
    buildUnitDatasets(consumptions, unitPayload, fallbackResponse = {}) {
      const safeConsumptions = Array.isArray(consumptions) ? consumptions.filter(Boolean) : [];
      if (!safeConsumptions.length) {
        return { labels: [], dataset: [] };
      }

      const labels = safeConsumptions.map((consumption) => {
        const date = this.parseSafeDate(consumption?.time) || new Date();
        return this.formatLabelByMode(date);
      });
      const estimatedFlags = safeConsumptions.map((consumption) => Boolean(consumption?.isEstimative));
      const waterValues = safeConsumptions.map((consumption) => {
        const rawValue = this.normalizeNumber(consumption?.valueWater, 0) / 1000;
        return +(this.scaleChartValue(rawValue).toFixed(2));
      });
      const sewerValues = safeConsumptions.map((consumption) => {
        const rawValue = this.normalizeNumber(consumption?.valueSewer, 0) / 1000;
        return +(this.scaleChartValue(rawValue).toFixed(2));
      });
      const waterBaseline = this.buildUnitAverageSeries(
        safeConsumptions,
        this.normalizeNumber(fallbackResponse.totalWaterAverageCurrent) !== null
          ? this.normalizeNumber(fallbackResponse.totalWaterAverageCurrent) / 1000
          : null
      );
      const sewerBaseline = this.buildUnitAverageSeries(
        safeConsumptions,
        this.normalizeNumber(fallbackResponse.totalSewerAverageCurrent) !== null
          ? this.normalizeNumber(fallbackResponse.totalSewerAverageCurrent) / 1000
          : null
      );

      const waterBar = {
        label: 'Água',
        data: waterValues,
        backgroundColor: estimatedFlags.map((estimated) => estimated ? '#87B9FD' : '#0E76BC'),
        borderColor: estimatedFlags.map((estimated) => estimated ? '#87B9FD' : '#0E76BC'),
        borderSkipped: false,
        order: 10,
      };
      const sewerBar = {
        label: 'Efluentes',
        data: sewerValues,
        backgroundColor: estimatedFlags.map((estimated) => estimated ? '#F6B37A' : '#D96B1D'),
        borderColor: estimatedFlags.map((estimated) => estimated ? '#F6B37A' : '#D96B1D'),
        borderSkipped: false,
        order: 10,
      };
      const waterLine = {
        label: 'MÃ©dia Ãgua',
        data: waterBaseline,
        type: 'line',
        borderColor: '#005B52',
        backgroundColor: '#005B52',
        borderWidth: 3,
        borderDash: [8, 6],
        fill: false,
        pointRadius: 0,
        tension: 0,
        order: 0,
      };
      const sewerLine = {
        label: 'MÃ©dia Efluentes',
        data: sewerBaseline,
        type: 'line',
        borderColor: '#9C4310',
        backgroundColor: '#9C4310',
        borderWidth: 3,
        borderDash: [8, 6],
        fill: false,
        pointRadius: 0,
        tension: 0,
        order: 0,
      };

      const datasetsByMode = {
        total: [waterBar, sewerBar, waterLine, sewerLine],
        water: [waterBar, waterLine],
        sewer: [sewerBar, sewerLine],
      };

      return {
        labels,
        dataset: datasetsByMode[this.kpiViewMode] || datasetsByMode.total,
      };
    },
    buildUnitChartCard(unitId, entry) {
      const unitPayload = this.getSelectedUnitPayload(unitId);
      const rawData = entry.rawConsumptionData || {};
      const consumptions = Array.isArray(rawData.consumptions) ? rawData.consumptions : [];
      const graph = this.buildUnitDatasets(consumptions, unitPayload, rawData);
      return {
        unit_id: unitId,
        unit_name: '',
        subtitle: '',
        tariffChips: this.buildUnitTariffChips(unitPayload),
        labels: graph.labels,
        dataset: graph.dataset,
      };
    },
    buildSummedUnitGraph(entries) {
      const grouped = {};
      const keys = [];

      entries.forEach(({ unitId, entry }) => {
        const consumptions = Array.isArray(entry?.rawConsumptionData?.consumptions)
          ? entry.rawConsumptionData.consumptions.filter(Boolean)
          : [];
        if (!consumptions.length) return;
        const waterBaseline = this.buildUnitAverageSeries(
          consumptions,
          this.normalizeNumber(entry.rawConsumptionData?.totalWaterAverageCurrent) !== null
            ? this.normalizeNumber(entry.rawConsumptionData.totalWaterAverageCurrent) / 1000
            : null
        );
        const sewerBaseline = this.buildUnitAverageSeries(
          consumptions,
          this.normalizeNumber(entry.rawConsumptionData?.totalSewerAverageCurrent) !== null
            ? this.normalizeNumber(entry.rawConsumptionData.totalSewerAverageCurrent) / 1000
            : null
        );

        consumptions.forEach((consumption, index) => {
          const parsedDate = this.parseSafeDate(consumption?.time);
          if (!parsedDate) return;
          const key = parsedDate.toISOString();
          if (!grouped[key]) {
            grouped[key] = {
              date: parsedDate,
              water: 0,
              sewer: 0,
              waterBaseline: 0,
              sewerBaseline: 0,
              isEstimative: false,
            };
            keys.push(key);
          }

          grouped[key].water += this.scaleChartValue(this.normalizeNumber(consumption?.valueWater, 0) / 1000) || 0;
          grouped[key].sewer += this.scaleChartValue(this.normalizeNumber(consumption?.valueSewer, 0) / 1000) || 0;
          grouped[key].waterBaseline += Number(waterBaseline[index]) || 0;
          grouped[key].sewerBaseline += Number(sewerBaseline[index]) || 0;
          grouped[key].isEstimative = grouped[key].isEstimative || Boolean(consumption?.isEstimative);
        });
      });

      const ordered = keys.map((key) => grouped[key]);
      if (!ordered.length) {
        return {
          title: '',
          subtitle: '',
          labels: [],
          dataset: [],
        };
      }
      const labels = ordered.map((item) => this.formatLabelByMode(item.date));

      const waterBar = {
        label: 'Água',
        data: ordered.map((item) => +item.water.toFixed(2)),
        backgroundColor: ordered.map((item) => item.isEstimative ? '#7FD9D1' : '#00897B'),
        borderColor: ordered.map((item) => item.isEstimative ? '#7FD9D1' : '#00897B'),
        borderSkipped: false,
        order: 10,
      };
      const sewerBar = {
        label: 'Efluentes',
        data: ordered.map((item) => +item.sewer.toFixed(2)),
        backgroundColor: ordered.map((item) => item.isEstimative ? '#F6B37A' : '#D96B1D'),
        borderColor: ordered.map((item) => item.isEstimative ? '#F6B37A' : '#D96B1D'),
        borderSkipped: false,
        order: 10,
      };
      const waterLine = {
        label: 'Baseline Água',
        data: ordered.map((item) => +item.waterBaseline.toFixed(2)),
        type: 'line',
        borderColor: '#005B52',
        backgroundColor: '#005B52',
        borderWidth: 3,
        borderDash: [8, 6],
        fill: false,
        pointRadius: 0,
        tension: 0,
        order: 0,
      };
      const sewerLine = {
        label: 'Baseline Efluentes',
        data: ordered.map((item) => +item.sewerBaseline.toFixed(2)),
        type: 'line',
        borderColor: '#9C4310',
        backgroundColor: '#9C4310',
        borderWidth: 3,
        borderDash: [8, 6],
        fill: false,
        pointRadius: 0,
        tension: 0,
        order: 0,
      };

      const datasetsByMode = {
        total: [waterBar, sewerBar, waterLine, sewerLine],
        water: [waterBar, waterLine],
        sewer: [sewerBar, sewerLine],
      };

      return {
        title: '',
        subtitle: '',
        labels,
        dataset: datasetsByMode[this.kpiViewMode] || datasetsByMode.total,
      };
    },
    rebuildUnitCharts() {
      const unitEntries = Object.entries(this.resume || {})
        .filter(([key, value]) => key !== 'goal' && value && value.rawConsumptionData)
        .map(([unitId, entry]) => ({ unitId, entry }));

      if (!unitEntries.length) {
        this.unitsDataGraphic = [];
        this.summedGraphs = [];
        return false;
      }

      const charts = unitEntries
        .map(({ unitId, entry }) => this.buildUnitChartCard(unitId, entry))
        .filter((chart) => chart && Array.isArray(chart.dataset));

      const hasMultipleUnits = unitEntries.length > 1;
      this.unitsDataGraphic = hasMultipleUnits ? [] : charts;
      this.summedGraphs = hasMultipleUnits ? [this.buildSummedUnitGraph(unitEntries)] : [];
      if (this.summedGraphs.length && (!Array.isArray(this.summedGraphs[0].dataset) || !this.summedGraphs[0].dataset.length)) {
        this.summedGraphs = [];
      }
      this.readings = [];
      return hasMultipleUnits ? this.summedGraphs.length > 0 : charts.length > 0;
    },

    mountGroupDataChart(allConsumptions) {
      const baseHexWater = "2FA4DD";
      const baseHexSewer = "D97706";
      const labels = allConsumptions[0].consumptions.map(consumption => {
        const date = new Date(consumption.time);
        return this.formatLabelByMode(date);
      });
      const currentDate = new Date();
      const dataset = allConsumptions.flatMap((unit, index) => [
        {
          data: unit.consumptions.map(consumption => consumption.valueWater),
          label: 'Água: ' + unit.unit_name,
          backgroundColor: unit.consumptions.map(consumption =>
            new Date(consumption.time) > currentDate ? this.shadeColor('#0ffc03', index * -30) : this.shadeColor(baseHexWater, index * -30)
          ),
          borderColor: unit.consumptions.map(consumption =>
            new Date(consumption.time) > currentDate ? this.shadeColor('#0ffc03', index * -30) : this.shadeColor(baseHexWater, index * -30)
          ),
          stack: index,
          fill: false,
          draw: false,
          borderSkipped: false,
          order: 1,
          barPercentage: 0.8, // Ajuste essa porcentagem conforme necessário
          categoryPercentage: 0.8, // Ajuste essa porcentagem conforme necessário
          maxBarThickness: 40, // Ajuste conforme necessário
        }
        ,
        {
          label: 'Efluentes: ' + unit.unit_name,
          data: unit.consumptions.map(consumption => consumption.valueSewer),
          backgroundColor: unit.consumptions.map(consumption =>
            new Date(consumption.time) > currentDate ? this.shadeColor('#FFB86B', index * -30) : this.shadeColor(baseHexSewer, index * -30)
          ),
          borderColor: unit.consumptions.map(consumption =>
            new Date(consumption.time) > currentDate ? this.shadeColor('#FFB86B', index * -30) : this.shadeColor(baseHexSewer, index * -30)
          ),
          stack: index,
          fill: false,
          draw: false,
          borderSkipped: false,
          order: 1,
          barPercentage: 0.8, // Ajuste essa porcentagem conforme necessário
          categoryPercentage: 0.8, // Ajuste essa porcentagem conforme necessário
          maxBarThickness: 40, // Ajuste conforme necessário
        }
      ]
      )



      return { labels, dataset }
    },
    sumConsumptionsByDate(allConsumptions) {

      const consumptionMap = {};
      let totalWater = 0;
      let totalSewer = 0;

      allConsumptions.forEach(unit => {
        unit.consumptions.forEach(consumption => {
          const date = new Date(consumption.time).toISOString();
          if (!consumptionMap[date]) {
            consumptionMap[date] = { valueWater: 0, valueSewer: 0 };
          }
          consumptionMap[date].valueWater += consumption.valueWater;
          consumptionMap[date].valueSewer += consumption.valueSewer;

          totalWater += consumption.valueWater;
          totalSewer += consumption.valueSewer;
        });
      });

      const results = Object.entries(consumptionMap).map(([time, values]) => ({
        time,
        ...values
      }));

      const averageWater = results.length ? totalWater / results.length : 0;
      const averageSewer = results.length ? totalSewer / results.length : 0;
      const consumptions = {
        summedConsumptions: results,
        averageWater,
        averageSewer
      };

      const labels = consumptions.summedConsumptions.map(consumption => {
        const date = new Date(consumption.time);
        return this.formatLabelByMode(date);
      });

      const currentDate = new Date();
      const goalValueSum = this.getGoalConsumptionByPeriod();

      const waterDataset = {
        label: 'Água',
        data: consumptions.summedConsumptions.map(consumption => +(consumption.valueWater.toFixed(2))),
        backgroundColor: consumptions.summedConsumptions.map(consumption =>
          new Date(consumption.time) > currentDate ? '#0ffc03' : '#2FA4DD'
        ),
        borderColor: consumptions.summedConsumptions.map(consumption =>
          new Date(consumption.time) > currentDate ? '#0ffc03' : '#2FA4DD'
        ),
        fill: false,
        draw: false,
        borderSkipped: false,
        order: 1,
        unitMeasure: this.unitMeasureVuex
      };

      // Adicionar meta de consumo se disponível
      if (goalValueSum !== null && goalValueSum !== undefined && !isNaN(goalValueSum)) {
        waterDataset.goalConsumption = parseFloat(goalValueSum.toFixed(2));
      }

      const dataset = [
        waterDataset,
        {
          label: 'Efluentes',
          backgroundColor: consumptions.summedConsumptions.map(consumption =>
            new Date(consumption.time) > currentDate ? '#FFB86B' : '#F28C28'
          ),
          borderColor: consumptions.summedConsumptions.map(consumption =>
            new Date(consumption.time) > currentDate ? '#FFB86B' : '#F28C28'
          ),
          data: consumptions.summedConsumptions.map(consumption => +(consumption.valueSewer.toFixed(2))),
          fill: false,
          draw: false,
          borderSkipped: false,
          // barThickness: 30,
          order: 1
        },
        {
          label: 'Média Água',
          data: Array(labels.length).fill(averageWater), // Cria um array com a média repetida
          type: 'line',
          borderColor: '#0E76BC',
          backgroundColor: '#0E76BC',
          borderWidth: 1,
          fill: false,
          pointRadius: 0, // Remove os pontos da linha
          order: 2,
        },
        // Linha média para Consumo de Esgoto
        {
          label: 'Média Efluentes',
          data: Array(labels.length).fill(averageSewer), // Cria um array com a média repetida
          type: 'line',
          borderColor: '#C96A12',
          backgroundColor: '#C96A12',
          borderWidth: 1,
          fill: false,
          pointRadius: 0, // Remove os pontos da linha
          order: 2,
        },
      ]

      return { labels, dataset }
    },
    async generateAllConsumption(isToPredict = true) {
      const toM3 = (liters = 0) => liters / 1000;
      // Snapshot simple guard values to detect changes during async operations
      const startPeriod = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
      const startSelectedCount = Array.isArray(this.selectedUnitSum) ? this.selectedUnitSum.length : (Array.isArray(this.selectedUnits) ? this.selectedUnits.length : 0);
      // Defesa: se estamos no período estimado e há múltiplas unidades, não executar cálculos
      const currentPeriod = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
      if (currentPeriod === 'estimed' && Array.isArray(this.selectedUnitSum) && this.selectedUnitSum.length > 1) {
        // Informar usuário e interromper sem alterar estados para evitar corrupção
        showInfoSnackBar("Não é possível calcular múltiplas unidades com o período 'Estimado'. Selecione apenas uma unidade ou altere o período.");
        return false;
      }

      this.generatingChart = true
      this.resume = {}
      this.readings = []
      this.resetKpiMetrics()
      let modems = []
      const { startDate, endDate } = this.getPeriod()
      if (startDate == null || endDate == null) {
        return true
      }
      let filteredSelectedSector = this.selectedSector;
      if (Array.isArray(this.selectedSector) && Array.isArray(this.selectedUnitSum)) {
        filteredSelectedSector = this.selectedSector.filter(sector => {
          return !this.selectedUnitSum.some(unitSum => unitSum.id === sector.id_unit);
        });
      }
      if (!Array.isArray(filteredSelectedSector)) {
        modems.push(filteredSelectedSector)
      } else {
        modems = filteredSelectedSector
      }
      let permittedStartDate = null;
      let permittedEndDate = null;
      let resume = {};
      let labels = [];

      if (Array.isArray(modems) && modems.length > 0) {
        ({ permittedStartDate, permittedEndDate, resume, labels } = await this.generateSectorTariffConsumption(
          startDate,
          endDate,
          modems
        ));
      }
      let datas = []
      if (this.selectedUnitSum.length > 0) {
        let adjustedEndDate = this.selectedPeriod != 'hour' ? new Date(endDate.getTime() - 24 * 60 * 60 * 1000) : endDate
        const execFuncs = this.selectedUnitSum.map(unitSum => ({
          unit_id: unitSum.id,
          unit_name: unitSum.title,
          promise: ConsumptionService.consumptionByUnitByTariff({
            start_date: startDate,
            end_date: adjustedEndDate,
            mode: this.dateOptions.mode,
            unit_measurement: this.unitMeasureVuex,
            unit_id: unitSum.id,
            includeInvoicedOnly: true,
          })
        }))
        await Promise.all(execFuncs.map(obj => obj.promise)).then((values) => {
          datas = values.reduce((acc, value, index) => {
            const unitId = execFuncs[index].unit_id;
            const unitName = execFuncs[index].unit_name;
            const consumptions = value.data.data.consumptions || [];
            const totalWaterMeasured = value.data.data.totalWaterMeasured || 0;
            const totalSewerMeasured = value.data.data.totalSewerMeasured || 0;
            const totalWaterAverageCurrent = value.data.data.totalWaterAverageCurrent || 0;
            const totalSewerAverageCurrent = value.data.data.totalSewerAverageCurrent || 0;
            const totalWaterEstimatedTotal = value.data.data.totalWaterEstimatedTotal || 0;
            const totalSewerEstimatedTotal = value.data.data.totalSewerEstimatedTotal || 0;
            // Soma água + esgoto para o consumo total registrado
            const consumptionTotal = totalWaterMeasured + totalSewerMeasured;
            //console.log("CONSUMPTION TOTAL FROM API", consumptionTotal);
            // Soma água + esgoto para a média
            const average = totalWaterAverageCurrent + totalSewerAverageCurrent;
            //console.log("AVERAGE FROM API", average);
            const estimatedTotal = totalWaterEstimatedTotal + totalSewerEstimatedTotal;
            //console.log("ESTIMATED TOTAL FROM API", estimatedTotal);
            acc[unitId] = {
              // IMPORTANTE: Os 3 valores abaixo SEMPRE estão em M³ (metros cúbicos)
              measured_total: toM3(consumptionTotal), // Valor medido total em M³
              average: toM3(average), // Média em M³
              estimatedTotal: toM3(estimatedTotal), // Valor estimado total em M³
              measured_water: toM3(totalWaterMeasured),
              measured_sewer: toM3(totalSewerMeasured),
              average_water: toM3(totalWaterAverageCurrent),
              average_sewer: toM3(totalSewerAverageCurrent),
              estimated_water: toM3(totalWaterEstimatedTotal),
              estimated_sewer: toM3(totalSewerEstimatedTotal),
              modemName: unitName,
              labels: consumptions.map(consumption => {
                const date = new Date(consumption.time);
                return this.formatLabelByMode(date);
              }),
              readings: consumptions.map(consumption => {
                const date = new Date(consumption.time);
                return {
                  date: date,
                  label: this.formatLabelByMode(date),
                  water: ((consumption.valueWater || 0) + (consumption.valueSewer || 0)) / 1000,
                  waterValue: (consumption.valueWater || 0) / 1000,
                  sewerValue: (consumption.valueSewer || 0) / 1000,
                  isEstimative: false
                };
              }),
              rawConsumptionData: value.data.data,
              modemId: "somaTotal"
            };

            return acc;
          }, {});
        })
      }

      if (datas && Object.keys(datas).length > 0) {
        // Antes de aplicar os resultados, confirmar que o período e seleção não mudaram durante as chamadas assíncronas
        const currentPeriodAfter = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
        const currentSelectedCountAfter = Array.isArray(this.selectedUnitSum) ? this.selectedUnitSum.length : (Array.isArray(this.selectedUnits) ? this.selectedUnits.length : 0);
        if ((currentPeriodAfter === 'estimed' && currentSelectedCountAfter > 1) || currentSelectedCountAfter !== startSelectedCount || currentPeriodAfter !== startPeriod) {
          return false;
        }

        this.resume = { ...resume, ...datas };
        this.kpiMetricsRaw = this.buildKpiMetricsFromResume(this.resume);
        this.updateDisplayedKpis();
        // Usar getEstimatedTotal que já soma todos os estimatedTotal em M³ e formata para exibição
        //console.log("RESUME UNITS", this.resume)

      } else {
        const currentPeriodAfter = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
        const currentSelectedCountAfter = Array.isArray(this.selectedUnitSum) ? this.selectedUnitSum.length : (Array.isArray(this.selectedUnits) ? this.selectedUnits.length : 0);
        if ((currentPeriodAfter === 'estimed' && currentSelectedCountAfter > 1) || currentSelectedCountAfter !== startSelectedCount || currentPeriodAfter !== startPeriod) {
          return false;
        }

        this.resume = resume;
        this.kpiMetricsRaw = this.buildKpiMetricsFromResume(this.resume);
        this.updateDisplayedKpis();
        //console.log("RESUME SECTOR", this.resume)
      }

      this.permittedStartDate = permittedStartDate;
      this.permittedEndDate = permittedEndDate;
      this.totalDates = labels.length;
      this.generatingChart = false
    },
    // Filtragem do consumo pelo Gráfico. Onde serão mostrados os consumos no gráfico: 
    //    por 7 dias     -> registros dos últimos 7 dias
    //    por dia        -> registros dos dias de um mês específico
    //    por hora       -> registros por hora de um dia específico
    //    por intervalo  -> registros por hora em intervalo definido
    async consultConsumptionGraphic() {
      // Bloqueio: não permitir consulta de múltiplas unidades com período estimado
      const currentPeriod = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
      if (currentPeriod === 'estimed' && Array.isArray(this.selectedUnitSum) && this.selectedUnitSum.length > 1) {
        showInfoSnackBar("Não é possível consultar múltiplas unidades com o período 'Estimado'. Selecione apenas uma unidade ou altere o período.");
        // Mantém KPIs visíveis, impede atualização do gráfico
        this.isDataGraphic = false;
        this.isKPI = true;
        this.consultReading = false;
        this.loadingReadings = false;
        return;
      }

      this.generatingChart = true;
      try {
        this.graphicFlag = true;
        this.consultTable = false;
        this.isDataGraphic = false;

        if (this.$refs.formConsumption && !this.$refs.formConsumption.validate()) {
          this.generatingChart = false;
          return;
        }

        // Ativa flags que permite fazer a impressão e também flag de carregamento dos dados (vue loading)
        this.isDataTable = false;
        this.unitsDataGraphic = [];
        this.summedGraphs = [];
        this.loadingReadings = true;
        this.validDayPeriodSelected = true;
        this.validHourPeriodSelected = true;
        this.validMonthPeriodSelected = true;

        const match = String(this.adjustedAverage).match(/[\d,.]+/);
        const averageBeforeFozValue = match ? parseFloat(match[0].replace('.', '')) : 0;
        const matchGoal = String(this.unitSelectedDataKPIs.goalPercentage).match(/[\d,.]+/);
        const goalPercentageValue = matchGoal ? parseFloat(matchGoal[0].replace('.', '')) : 0;
        this.goalMonth = parseFloat((averageBeforeFozValue * ((100 - goalPercentageValue) / 100)).toFixed(2));

        this.consultDatalLoading.graphicButton = true
        var isConsumptionGenerated = await this.generateAllConsumption()
        this.consultDatalLoading.graphicButton = false

        // Se a geração foi abortada (período/seleção mudou durante as chamadas assíncronas), não continuar com recalculos
        if (isConsumptionGenerated === false) {
          this.generatingChart = false;
          this.loadingReadings = false;
          this.consultReading = false;
          this.consultGraph = false;
          this.isDataGraphic = false; // manter KPIs visíveis
          this.isKPI = true;
          return;
        }

        this.sumSingleResumeReadingsWater(this.resume);
        // Calcular meta de consumo ajustada conforme período
        const goalConsumptionValue = this.getGoalConsumptionByPeriod();
        const hasUnitSelection = Array.isArray(this.selectedUnitSum) && this.selectedUnitSum.length > 0;
        if (hasUnitSelection) {
          this.rebuildUnitCharts();
        } else {
        this.readings = await ConsumptionFunctionsByTariff.createDatasetByTariff(this.resume, this.kpiViewMode)
        }
        try {
          this.kpiMetricsRaw = this.buildKpiMetricsFromResume(this.resume);
          this.updateDisplayedKpis();
        } catch (err) {
          console.warn('Não foi possível recalcular KPIs após leitura do gráfico', err)
        }
        const resumeKeys = Object.keys(this.resume).filter(key => key !== 'goal');
        this.dynamicHeight = '80vh'
        this.isKPI = true
        if (!hasUnitSelection && resumeKeys.length > 1 && !this.resume?.goal) {
          this.resume.groupReadings = {
            modemName: "DADOS AGRUPADOS",
          };
          this.readings = [this.groupReadings()]

          // if (!this.checkSameUnit()) {
          //   this.dynamicHeight = '90vh'
          //   this.isKPI = false
          // }
        }

        this.consultReading = false;
        this.loadingReadings = false;
        this.consultGraph = false;        // Fecha modal de gráfico
        if (isConsumptionGenerated) {
          this.selectsModal = true
        } else {
          this.isDataGraphic = true;        // Exibe gráfico  
          this.selectsModal = false
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.generatingChart = false;
      }
    },
    async startPdf() {
      if (this.selectedSector.length === 0) {
        showInfoSnackBar("Nenhum setor encontrado para gerar o PDF")
        return
      }
      try {
        await this.getPeriod()
      } catch (error) {
        console.error('Error getting period: ', error)
      }
      if (this.$refs.formConsumption && !this.$refs.formConsumption.validate()) return;

      // Bloqueio: não permitir gerar PDF para múltiplas unidades quando período estimado
      const currentPeriod = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
      if (currentPeriod === 'estimed' && Array.isArray(this.selectedUnitSum) && this.selectedUnitSum.length > 1) {
        showInfoSnackBar("Não é possível gerar PDF para múltiplas unidades com o período 'Estimado'. Selecione apenas uma unidade ou altere o período.");
        return;
      }

      try {
        if (!this.checkSameUnit()) {
          showInfoSnackBar("Selecione apenas uma unidade para gerar o PDF")
          return
        }
        this.loadButtonPdf = true
        this.exporting = true
        //body passado para a API PDF
        const params = {
          selectedSector: this.selectedSector,
          period: this.selectedPeriod,
          currentUserId: store.state.currentUser?.uid,
          unitId: this.selectedUnits[0],
          modemIds: this.selectedSector.map(sector => sector.id_modem),
          unitMeasurement: this.unitMeasureVuex,
          isUnit: this.selectedUnitSum.length > 0 ? true : false,
          ...this.dateOptions
        }
        const response = await ConsumptionApi.generateConsumptionPdf(params)
        this.dialogDownload = true
        this.fileLink = response.data.signedUrl
        this.exporting = false

      } catch (error) {
        console.error(error)
        showErrorSnackBar("Erro ao gerar PDF! Entre em contato com nossa equipe!")
        this.exporting = false
      } finally { this.loadButtonPdf = false }
    },
    formatDate(date) {
      if (!date || typeof date !== 'string' || !date.includes('-')) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    async getPreviewDate() {
      try {
        const today = new Date();
        const unitSelected = this.listUnits.find(({ id }) => id === this.selectedUnits[0])
        if (unitSelected != undefined && typeof unitSelected.lastReadingDate != "undefined") {
          this.lastReadingDate = (new Date(unitSelected.lastReadingDate._seconds * 1000 + unitSelected.lastReadingDate._nanoseconds / 1e6))
          this.previewDate = new Date(this.lastReadingDate)
          while (this.previewDate <= today) {
            this.previewDate.setMonth(this.previewDate.getMonth() + 1)
          }
          this.previewDateCurrent = new Date(this.previewDate)
          this.previewDateCurrent.setDate(this.previewDate.getDate() - 30)
          this.dateFormattedSelectedPreviewStart = Utils.formatDate(this.previewDateCurrent, "<dd>/<MM>/<YYYY>")
          this.dateFormattedSelectedPreviewEnd = Utils.formatDate(this.previewDate, "<dd>/<MM>/<YYYY>")
        } else {
          this.dateFormattedSelectedPreviewStart = ''
          this.dateFormattedSelectedPreviewEnd = ''
          return
        }
      } catch (err) {
        console.error(err)
        showInfoSnackBar(err)
      }
    },
    debouncedGetSectors: debounce(function (e) {
      this.onChangeUnit(e);
    }, 1000),
    getGoalConsumptionByPeriod() {
      // Retorna a meta de consumo ajustada conforme o período selecionado
      // A meta de consumo mensal é: averageBeforeFoz * (1 - metaEconomy)
      // Só retorna a meta se uma unidade INTEIRA estiver selecionada (não apenas setores)
      if (!this.selectedUnitSum || this.selectedUnitSum.length === 0) {
        return null;
      }
      if (this.averageBeforeFozRaw === undefined || this.metaEconomy === undefined) {
        return null;
      }

      const unitMeasure = this.unitMeasureVuex;
      const goalConsumptionMonthly = this.averageBeforeFozRaw * (1 - this.metaEconomy);

      // Converter para litros se necessário
      const goalConsumptionMonthlyValue = unitMeasure === 'liters' ? goalConsumptionMonthly * 1000 : goalConsumptionMonthly;

      // Ajustar conforme o período selecionado
      const period = this.selectedPeriod;
      const mode = this.dateOptions?.mode || 'day';
      let adjustedGoal = goalConsumptionMonthlyValue;

      if (period === '7days') {
        // Últimos 7 dias: meta mensal / 30 (meta diária)
        adjustedGoal = goalConsumptionMonthlyValue / 30;
      } else if (period === 'day') {
        // Por dia: meta mensal / 30
        adjustedGoal = goalConsumptionMonthlyValue / 30;
      } else if (period === 'hour') {
        // Por hora: meta mensal / 30 / 24
        adjustedGoal = (goalConsumptionMonthlyValue / 30) / 24;
      } else if (period === 'month') {
        // Por mês: meta mensal (sem ajuste)
        adjustedGoal = goalConsumptionMonthlyValue;
      } else if (period === 'interval' || period === 'estimed') {
        // Por intervalo ou período estimado: depende do modo (day, hour ou month)
        if (mode === 'hour') {
          adjustedGoal = (goalConsumptionMonthlyValue / 30) / 24;
        } else if (mode === 'day') {
          adjustedGoal = goalConsumptionMonthlyValue / 30;
        } else if (mode === 'month') {
          adjustedGoal = goalConsumptionMonthlyValue;
        }
      } else {
        // Fallback: usar o modo se o período não for reconhecido
        if (mode === 'hour') {
          adjustedGoal = (goalConsumptionMonthlyValue / 30) / 24;
        } else if (mode === 'day') {
          adjustedGoal = goalConsumptionMonthlyValue / 30;
        } else if (mode === 'month') {
          adjustedGoal = goalConsumptionMonthlyValue;
        }
      }

      return adjustedGoal;
    },
    updateAdjustedAverage() {
      const formatValue = (value) => {
        return new Intl.NumberFormat('pt-BR').format(value);
      }
      const unitMeasure = this.unitMeasureVuex;
      let adjusted = this.averageBeforeFozRaw;
      let recorded = this.recordedConsumptionRaw
      let suffix = 'M³';
      if (unitMeasure === 'liters') {
        adjusted = this.averageBeforeFozRaw !== undefined ? this.averageBeforeFozRaw * 1000 : 'Não há dados';
        recorded = this.recordedConsumptionRaw !== undefined ? this.recordedConsumptionRaw * 1000 : 'Não há dados';
        suffix = 'L';
      }
      const goalEconomyValue = adjusted - (adjusted * this.metaEconomy);
      this.goalEconomy = isNaN(goalEconomyValue) ? 'Não há dados' : `${formatValue(goalEconomyValue)} ${suffix}`;
      this.adjustedAverage = isNaN(adjusted) ? 'Não há dados' : `${formatValue(adjusted)} ${suffix}`;
      if (recorded == undefined) this.recordedConsumption = 'Selecione um setor';
      else this.recordedConsumption = `${recorded.toLocaleString('pt-BR', { maximumFractionDigits: 2 })} ${suffix}`;
      this.goalEconomy = this.goalEconomy || '';
      this.adjustedAverage = this.adjustedAverage || '';
      this.recordedConsumption = this.recordedConsumption || ''
    },
    sumReadingsByIndex(resume) {
      // Nova lógica: somar resume[<id>].readings[m].water para todos os resumes e todos os m
      // Ignorar a chave 'goal'
      const validItems = Object.entries(resume)
        .filter(([key, value]) => key !== 'goal' && value && Array.isArray(value.readings))
        .map(([_, value]) => value);
      if (validItems.length === 0) return { readings: [], labels: [] };
      // Descobrir o maior número de readings
      const maxLen = Math.max(...validItems.map(item => item.readings.length));
      const summed = [];
      for (let i = 0; i < maxLen; i++) {
        let sum = 0;
        for (let item of validItems) {
          const arr = item.readings;
          // Somar o .water se existir
          if (arr[i] && typeof arr[i].water === 'number') {
            sum += arr[i].water;
          } else if (arr[i] && typeof arr[i].water_liters === 'number') {
            sum += arr[i].water_liters;
          } else if (arr[i] && typeof arr[i].value === 'number') {
            sum += arr[i].value;
          }
        }
        summed.push({ water: sum });
      }
      let anyLabels = null;
      for (const item of validItems) {
        if (Array.isArray(item.labels)) {
          anyLabels = [...item.labels];
          break;
        }
      }
      return { readings: summed, labels: anyLabels };
    },
    // Retorna a média de consumo (em M³) do resume
    // Suporta tanto resume de unidades quanto de setores
    getAverageConsumption(resume) {
      if (!resume || typeof resume !== 'object') return 0;
      const keys = Object.keys(resume).filter(k => k !== 'goal');
      if (!keys.length) return 0;
      // resume unit 
      if (keys.length === 1) {
        const key = keys[0];
        return resume[key]?.average || 0; // Valor em M³
      }

      // sectors resume - soma todas as médias
      let total = 0;
      keys.forEach(key => {
        const avg = resume[key]?.average;
        if (typeof avg === 'number') {
          total += avg;
        }
      });
      return total; // Valor em M³
    },



    // Extrai e soma measured_total (em M³) do resume para calcular consumo registrado
    // IMPORTANTE: O valor armazenado em recordedConsumptionRaw está SEMPRE em M³
    sumSingleResumeReadingsWater(resume) {
      const keys = Object.keys(resume).filter(k => k !== 'goal');
      this.recordedConsumptionRaw = 0;
      if (keys.length > 1) {
        let waterGroup = 0;
        for (let n = 0; n < keys.length; n++) {
          const key = keys[n];
          this.sumSingleResumeReadingsWater({ [key]: resume[key] });
          waterGroup += this.recordedConsumptionRaw || 0;
        }
        this.recordedConsumptionRaw = waterGroup;
        this.updateAdjustedAverage();
        return;
      }
      if (keys && resume[keys]) {
        this.recordedConsumptionRaw = resume[keys].measured_total || 0;
      } else {
        this.recordedConsumptionRaw = 0;
      }
      this.updateAdjustedAverage();
    },
    checkSameUnit() {
      if (this.selectedUnitSum.length > 1) return false;
      const firstUnitId = this.selectedSector[0].id_unit;
      const selectedUnitSumVerify = firstUnitId == this.selectedUnitSum[0]?.id || this.selectedUnitSum.length == 0;
      return this.selectedSector.every(sector => sector.id_unit === firstUnitId) && selectedUnitSumVerify;
    },
    groupReadings() {

      // Função para gerar cores derivadas de azul
      const generateBlueVariation = (index, total) => {
        // Base azul principal
        const baseBlue = { r: 64, g: 146, b: 255 }; // #4092FF

        const blueVariations = [
          { r: 64, g: 146, b: 255 },   // Azul original
          { r: 0, g: 46, b: 113 },     // Azul escuro
          { r: 0, g: 172, b: 193 },    // Azul ciano
          { r: 32, g: 73, b: 128 },    // Azul médio
          { r: 0, g: 123, b: 255 },    // Azul claro
          { r: 25, g: 118, b: 210 },   // Azul material
          { r: 0, g: 150, b: 136 },    // Verde azulado
          { r: 48, g: 63, b: 159 },    // Índigo
          { r: 0, g: 87, b: 183 },     // Azul profundo
          { r: 96, g: 125, b: 139 },   // Azul acinzentado
        ];
        // Se temos variações suficientes, usar elas
        if (index < blueVariations.length) {
          const color = blueVariations[index];
          return `#${color.r.toString(16).padStart(2, '0')}${color.g.toString(16).padStart(2, '0')}${color.b.toString(16).padStart(2, '0')}`.toUpperCase();
        }
        const hue = 210 + (index * 15) % 60; // Varia entre 210-270 (tons de azul)
        const saturation = 70 + (index * 5) % 30; // 70-100%
        const lightness = 40 + (index * 8) % 40; // 40-80%
        // Converter HSL para RGB
        const h = hue / 360;
        const s = saturation / 100;
        const l = lightness / 100;
        const c = (1 - Math.abs(2 * l - 1)) * s;
        const x = c * (1 - Math.abs((h * 6) % 2 - 1));
        const m = l - c / 2;
        let r, g, b;
        if (h < 1 / 6) {
          r = c; g = x; b = 0;
        } else if (h < 2 / 6) {
          r = x; g = c; b = 0;
        } else if (h < 3 / 6) {
          r = 0; g = c; b = x;
        } else if (h < 4 / 6) {
          r = 0; g = x; b = c;
        } else if (h < 5 / 6) {
          r = x; g = 0; b = c;
        } else {
          r = c; g = 0; b = x;
        }
        const rHex = Math.round((r + m) * 255).toString(16).padStart(2, '0');
        const gHex = Math.round((g + m) * 255).toString(16).padStart(2, '0');
        const bHex = Math.round((b + m) * 255).toString(16).padStart(2, '0');
        return `#${rHex}${gHex}${bHex}`.toUpperCase();
      };

      if (!Array.isArray(this.selectedSector) || !Array.isArray(this.readings)) return { datasets: [], labels: [] };
      const datasets = this.readings.map((sector, n) => {
        if (!this.readings[n] || !this.readings[n].datasets || !this.readings[n].datasets[0]) return null;
        const dataset0 = this.readings[n].datasets[0];
        const dataset1 = this.readings[n].datasets[1];
        const datasetCopy = JSON.parse(JSON.stringify(dataset0));
        if (this.kpiViewMode === 'total' && dataset1 && Array.isArray(dataset0.data) && Array.isArray(dataset1.data)) {
          datasetCopy.data = dataset0.data.map((val, idx) => {
            const val1 = typeof parseFloat(val) === 'number' ? parseFloat(val) : 0;
            const val2 = typeof parseFloat(dataset1.data[idx]) === 'number' ? parseFloat(dataset1.data[idx]) : 0;
            return val1 + val2;
          });
        }
        datasetCopy.label = this.getResumeData(this.readings[n].modemId, 'modemName');
        delete datasetCopy.order;
        delete datasetCopy.stack;
        datasetCopy.backgroundColor = generateBlueVariation(n, this.readings.length);
        datasetCopy.barPercentage = 0.8;
        datasetCopy.categoryPercentage = 0.8;
        return datasetCopy;
      }).filter(Boolean);
      return {
        datasets,
        labels: this.readings[0] && this.readings[0].labels ? this.readings[0].labels : [],
        modemId: "groupReadings"
      };
    },
    buildUnitChartSubtitle() {
      return `Gráfico da unidade • Visão ${this.selectedKpiModeLabel}`;
    },
    buildUnitAverageSeries(consumptions, averageValue) {
      const safeConsumptions = Array.isArray(consumptions) ? consumptions : [];
      const normalizedAverage = this.normalizeNumber(averageValue);
      const displayValue = typeof normalizedAverage === 'number'
        ? +this.scaleChartValue(normalizedAverage).toFixed(2)
        : null;
      return safeConsumptions.map(() => displayValue);
    },
    buildUnitDatasets(consumptions, unitPayload, fallbackResponse = {}) {
      const safeConsumptions = Array.isArray(consumptions) ? consumptions.filter(Boolean) : [];
      if (!safeConsumptions.length) {
        return { labels: [], dataset: [] };
      }

      const labels = safeConsumptions.map((consumption) => {
        const date = this.parseSafeDate(consumption?.time) || new Date();
        return this.formatLabelByMode(date);
      });
      const estimatedFlags = safeConsumptions.map((consumption) => Boolean(consumption?.isEstimative));
      const waterValues = safeConsumptions.map((consumption) => {
        const rawValue = this.normalizeNumber(consumption?.valueWater, 0) / 1000;
        return +(this.scaleChartValue(rawValue).toFixed(2));
      });
      const sewerValues = safeConsumptions.map((consumption) => {
        const rawValue = this.normalizeNumber(consumption?.valueSewer, 0) / 1000;
        return +(this.scaleChartValue(rawValue).toFixed(2));
      });
      const waterAverage = this.buildUnitAverageSeries(
        safeConsumptions,
        this.normalizeNumber(fallbackResponse.totalWaterAverageCurrent) !== null
          ? this.normalizeNumber(fallbackResponse.totalWaterAverageCurrent) / 1000
          : null
      );
      const sewerAverage = this.buildUnitAverageSeries(
        safeConsumptions,
        this.normalizeNumber(fallbackResponse.totalSewerAverageCurrent) !== null
          ? this.normalizeNumber(fallbackResponse.totalSewerAverageCurrent) / 1000
          : null
      );

      const waterBar = {
        label: 'Água',
        data: waterValues,
        backgroundColor: estimatedFlags.map(() => '#87B9FD'),
        borderColor: estimatedFlags.map(() => '#87B9FD'),
        borderSkipped: false,
        barPercentage: this.kpiViewMode === 'total' ? 0.98 : 0.88,
        categoryPercentage: this.kpiViewMode === 'total' ? 0.72 : 0.82,
        maxBarThickness: this.kpiViewMode === 'total' ? 42 : 50,
        order: 10,
      };
      const sewerBar = {
        label: 'Efluentes',
        data: sewerValues,
        backgroundColor: estimatedFlags.map((estimated) => estimated ? '#FFF1E5' : '#F2B27B'),
        borderColor: estimatedFlags.map((estimated) => estimated ? '#FFF1E5' : '#F2B27B'),
        borderSkipped: false,
        barPercentage: 0.98,
        categoryPercentage: 0.72,
        maxBarThickness: 42,
        order: 10,
      };
      const waterLine = {
        label: 'Média Água',
        data: waterAverage,
        type: 'line',
        borderColor: '#0A317F',
        backgroundColor: '#0A317F',
        borderWidth: 2,
        borderDash: [10, 6],
        fill: false,
        pointRadius: 0,
        tension: 0,
        order: 0,
      };
      const sewerLine = {
        label: 'Média Efluentes',
        data: sewerAverage,
        type: 'line',
        borderColor: '#B56A2A',
        backgroundColor: '#B56A2A',
        borderWidth: 2,
        borderDash: [10, 6],
        fill: false,
        pointRadius: 0,
        tension: 0,
        order: 0,
      };

      const datasetsByMode = {
        total: [waterBar, sewerBar, waterLine, sewerLine],
        water: [waterBar, waterLine],
        sewer: [sewerBar, sewerLine],
      };

      return {
        labels,
        dataset: datasetsByMode[this.kpiViewMode] || datasetsByMode.total,
      };
    },
    buildSummedUnitGraph(entries) {
      const grouped = {};
      const keys = [];

      entries.forEach(({ entry }) => {
        const consumptions = Array.isArray(entry?.rawConsumptionData?.consumptions)
          ? entry.rawConsumptionData.consumptions.filter(Boolean)
          : [];
        if (!consumptions.length) return;

        const waterAverage = this.buildUnitAverageSeries(
          consumptions,
          this.normalizeNumber(entry.rawConsumptionData?.totalWaterAverageCurrent) !== null
            ? this.normalizeNumber(entry.rawConsumptionData.totalWaterAverageCurrent) / 1000
            : null
        );
        const sewerAverage = this.buildUnitAverageSeries(
          consumptions,
          this.normalizeNumber(entry.rawConsumptionData?.totalSewerAverageCurrent) !== null
            ? this.normalizeNumber(entry.rawConsumptionData.totalSewerAverageCurrent) / 1000
            : null
        );

        consumptions.forEach((consumption, index) => {
          const parsedDate = this.parseSafeDate(consumption?.time);
          if (!parsedDate) return;
          const key = parsedDate.toISOString();

          if (!grouped[key]) {
            grouped[key] = {
              date: parsedDate,
              water: 0,
              sewer: 0,
              waterAverage: 0,
              sewerAverage: 0,
              isEstimative: false,
            };
            keys.push(key);
          }

          grouped[key].water += this.scaleChartValue(this.normalizeNumber(consumption?.valueWater, 0) / 1000) || 0;
          grouped[key].sewer += this.scaleChartValue(this.normalizeNumber(consumption?.valueSewer, 0) / 1000) || 0;
          grouped[key].waterAverage += Number(waterAverage[index]) || 0;
          grouped[key].sewerAverage += Number(sewerAverage[index]) || 0;
          grouped[key].isEstimative = grouped[key].isEstimative || Boolean(consumption?.isEstimative);
        });
      });

      const ordered = keys.map((key) => grouped[key]);
      if (!ordered.length) {
        return {
          title: '',
          subtitle: `Gráfico da unidade • Consolidado • Visão ${this.selectedKpiModeLabel}`,
          labels: [],
          dataset: [],
        };
      }

      const labels = ordered.map((item) => this.formatLabelByMode(item.date));
      const waterBar = {
        label: 'Água',
        data: ordered.map((item) => +item.water.toFixed(2)),
        backgroundColor: ordered.map(() => '#87B9FD'),
        borderColor: ordered.map(() => '#87B9FD'),
        borderSkipped: false,
        barPercentage: this.kpiViewMode === 'total' ? 0.98 : 0.88,
        categoryPercentage: this.kpiViewMode === 'total' ? 0.72 : 0.82,
        maxBarThickness: this.kpiViewMode === 'total' ? 42 : 50,
        order: 10,
      };
      const sewerBar = {
        label: 'Efluentes',
        data: ordered.map((item) => +item.sewer.toFixed(2)),
        backgroundColor: ordered.map((item) => item.isEstimative ? '#FFF1E5' : '#F2B27B'),
        borderColor: ordered.map((item) => item.isEstimative ? '#FFF1E5' : '#F2B27B'),
        borderSkipped: false,
        barPercentage: 0.98,
        categoryPercentage: 0.72,
        maxBarThickness: 42,
        order: 10,
      };
      const waterLine = {
        label: 'Média Água',
        data: ordered.map((item) => +item.waterAverage.toFixed(2)),
        type: 'line',
        borderColor: '#0A317F',
        backgroundColor: '#0A317F',
        borderWidth: 2,
        borderDash: [10, 6],
        fill: false,
        pointRadius: 0,
        tension: 0,
        order: 0,
      };
      const sewerLine = {
        label: 'Média Efluentes',
        data: ordered.map((item) => +item.sewerAverage.toFixed(2)),
        type: 'line',
        borderColor: '#B56A2A',
        backgroundColor: '#B56A2A',
        borderWidth: 2,
        borderDash: [10, 6],
        fill: false,
        pointRadius: 0,
        tension: 0,
        order: 0,
      };

      const datasetsByMode = {
        total: [waterBar, sewerBar, waterLine, sewerLine],
        water: [waterBar, waterLine],
        sewer: [sewerBar, sewerLine],
      };

      return {
        title: '',
        subtitle: `Gráfico da unidade • Consolidado • Visão ${this.selectedKpiModeLabel}`,
        labels,
        dataset: datasetsByMode[this.kpiViewMode] || datasetsByMode.total,
      };
    },
  },

  watch: {
    isSectorViewOnly(newValue) {
      return newValue;
    },
    optionMetric() {
      if (this.optionMetric == true) {
        this.switch1 = "Metros Cúbicos (m³)";
      } else {
        this.switch1 = "Litros (L)";
      }
    },
    dateSelectedEnd() {
      this.dateFormattedSelectedEnd = this.formatDate(this.dateSelectedEnd);
    },
    dateSelectedStart() {
      this.dateFormattedSelectedStart = this.formatDate(this.dateSelectedStart);
    },
    dateSelectedPreviewEnd() {
      this.dateFormattedSelectedPreviewEnd = this.formatDate(this.dateSelectedPreviewEnd);
    },
    dateSelectedPreviewStart() {
      this.dateFormattedSelectedPreviewStart = this.formatDate(this.dateSelectedPreviewStart);
    },
    dateSelected() {
      this.dateSelectedFormatted = this.formatDate(this.dateSelected);
    },
    optionPeriod() {
      this.getPreviewDate()
    },
    selectedSector() {
      this.getPreviewDate()
    },
    listSectors() {
      this.syncResolvedSectorTypes();
    },
    getSelectedUnit: {
      immediate: true,
      handler(newUnit) {
        if (newUnit) {
          this.selectedUnits = [newUnit.id];
          this.debouncedGetSectors(newUnit);
          this.syncResolvedUnitTariffs();
          // this.onChangeInfoUnit(newUnit);
        }
      }
    },
    listUnits() {
      this.syncResolvedUnitTariffs();
    },
    getSelectedSectors(newSectors) {
      this.syncSelectedSectorsFromVuex();
    },
    // Watcher para sincronizar unidades selecionadas do Vuex
    getSelectedUnits: {
      immediate: true,
      handler(newSum) {
        if (newSum && Array.isArray(newSum)) {
          this.selectedUnitSum = [...newSum];
          this.syncResolvedUnitTariffs();
          this.consultConsumptionGraphic()
        }
      }
    },
    unitMeasureVuex(newVal) {
      this.updateAdjustedAverage();
      this.consultConsumptionGraphic()
    },
    kpiViewMode() {
      this.updateDisplayedKpis();
      if (Array.isArray(this.selectedUnitSum) && this.selectedUnitSum.length > 0 && this.isDataGraphic) {
        this.rebuildUnitCharts();
      } else if (this.isDataGraphic) {
        this.readings = ConsumptionFunctionsByTariff.createDatasetByTariff(this.resume, this.kpiViewMode);
        const resumeKeys = Object.keys(this.resume || {}).filter(key => key !== 'goal');
        if (resumeKeys.length > 1 && !this.resume?.goal) {
          this.resume.groupReadings = {
            modemName: "DADOS AGRUPADOS",
          };
          this.readings = [this.groupReadings()]
        }
      }
    },
    selectedPeriodValueVuex(newVal) {
      this.consultConsumptionGraphic()
    }
  },
  async created() {
    this.resetKpiMetrics();
    this.selectsLoading.client = true
    const response = await UsersService.findAllClients()
    this.listClients = response.data.data
    this.selectsLoading.client = false
    if (this.listClients.length === 1) {
      this.selectedClient = this.listClients[0]
      await this.onChangeClient(this.selectedClient.id)
    }
    await this.syncSelectedSectorsFromVuex();
    // Se houver uma unidade já selecionada na RightSidebar ao entrar na tela de Consumo,
    // garante que seus setores (não RESERVOIR) sejam automaticamente selecionados.
    await this.ensureSectorsForSelectedUnitIfMissing();
  },
};
